'use strict';

var cloneDeep = require('lodash/cloneDeep');
var base = require('./base');
var utils = require('../util/utils');
var embroideryUtils = require('./embroideryUtils');
var EmbroideryData = embroideryUtils.EmbroideryData;
var EmbroideryUi = embroideryUtils.EmbroideryUi;
var Contrast = embroideryUtils.Contrast;
var setReactiveProperty = embroideryUtils.setReactiveProperty;
var replaceTags = embroideryUtils.replaceTags;
var carousels = require('../components/carousels');
var fyl = require('../components/fyl');
var store = {
    export: {},
    state: {},
    globals: {}
};

var limitMap = {
    TEXT: 3,
    STOCK: 2,
    CUSTOMLOGO: 2,
    FLAG: 2
};

var positionWarningData = {};

var designElements = ['STOCK', 'FLAG', 'CUSTOMLOGO'];
var logoUploadRunning = false;

// Validates conditions for 'add to bag' button enabling
// Allows multiple error types to not conflict
var addValidator = {
    errors: {
        incompleteTemplateName: false,
        tosCheck: true,
        get sectionErrorRaised() {
            return !store.state.valid;
        },
        get notEmpty() {
            return store.state.completeCount === 0;
        }
    },
    /**
     * set invalid if at least one error key is set to true
     * @returns {boolean} - valid/invalid
     */
    valid() {
        let keys = Object.keys(this.errors);
        let valid = true;

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (this.errors[key]) {
                valid = false;
            }
        }

        return valid;
    },
    /**
     * disable/enable add to bag
     */
    update() {
        store.cache.$addButtons.prop('disabled', !this.valid());
    },
    /**
     * set an error and call field disable/enable
     * @param {string} error - error key
     * @param {boolean} state - is error true/false
     */
    set(error, state) {
        if (this.errors[error] !== undefined) {
            this.errors[error] = state;
        }

        this.update();
    }
};

/**
 * Hides/Shows the add new component button. Because the button display depends on how many components of that type already exist,
 * code needs to run after all components loaded, or multiple times while they get loaded
 */
function renderNewLineCtas() {
    let keys = Object.keys(store.state.sections);

    for (let i = 0; i < keys.length; i++) {
        const section = store.state.sections[keys[i]];
        let forms = section.getForms();
        let limit = limitMap[section.type];
        let count = store.export.data.filter(componentData => componentData.component === section.type).length;

        forms.forEach((form, index) => {
            if (form.$el) {
                // Hide add new component button if component isn't the last one, or it's the last allowed
                if (((index + 1) < count || (index + 1) === limit) || !form.complete) {
                    $('.add-line', form.$el).hide();
                } else {
                    $('.add-line', form.$el).show();
                    let addLine = $('.add-line', form.$el).text();
                    if (addLine.indexOf('#') <= 0) {
                        addLine = addLine + ' #' + (count + 1);
                        $('.add-line', form.$el).text(addLine);
                    }
                }
            }
        });
    }
}

/**
 * Clear saved embroidery data from localstorage
 */
function clearStoredEmbroidery() {
    if (window.localStorage.getItem('embroideryResume')) {
        window.localStorage.removeItem('embroideryResume');
    }
}

/**
 * Destroys the embroidery data object and clears references from localstorage, causing a fresh load on the next request
 */
function embroideryDestroy() {
    clearStoredEmbroidery();

    window.store = null;
}

/**
 * Shows an informational tooltip regarding zoom if 'don't show again' cookie hasn't been set
 */
function showZoomInfoTooltip() {
    if (!~document.cookie.indexOf('ignoreZoomInfo')) {
        let placement = store.globals.selectedPlacement;
        let $placementButton = $(`.image-selection-circle[data-location="${placement.valueId}"]`);

        // Show tooltip and add a custom class
        $($placementButton.tooltip('show').data('bs.tooltip').tip).addClass('zoom-info-tooltip');

        setTimeout(() => {
            $placementButton.tooltip('hide');
        }, 5000);
    }
}

/**
 * Tooltip for go to summary button
 * @param {Object} $el - the tooltip initiator element
 * @param {Function | boolean} condition - evaluator function || boolean value to toggle tooltip on off
 * @param {string} customClass - a custom class name to add to tooltip
 */
function toggleTooltip($el, condition, customClass) {
    let toggleCheck = condition && typeof condition === 'function' ? condition() : true;
    if ($el && $el.length && !$el.data('toolipVisible')) {
        if (toggleCheck) {
            // Show tooltip and add a custom class
            if (customClass) {
                // This determines the content of the tooltip
                var extraClass;
                if ($el.hasClass('button-go-to-review')) {
                    extraClass = ' review-btn';
                } else {
                    extraClass = ' other-btn';
                }
                $($el.tooltip('show').data('bs.tooltip').tip).addClass(customClass + extraClass).css('--var-margin-left', $('.' + customClass).outerWidth());
            } else {
                $el.tooltip('show');
            }
            $el.data('toolipVisible', true);

            setTimeout(() => {
                $el.tooltip('hide');
                $el.data('toolipVisible', false);
            }, 4000);
        }
    }
}

/**
 * Scale text component font size depending on wrapper width and:
 * - greatest number of characters in any text line
 * - number of text lines
 * - the presence of another component in the same preview
 * @param {Object} $wrapper - Text component wrapper
 * @param {number} componentsNo - number of separate components rendered in the same preview slot
 */

/**
 * Renders an embroidery preview for a specified placement location
 * Injects components in the preview grid according to 'positioning' option and scales them
 *
 * |                    above text slot                   |
 *
 * | left of text slot | text slot  | right of text slot  |
 *
 * |                    below text slot                   |
 *
 * @param {Object} placementData - The placement data, used to search components for the placement and render it's label
 * @param {Object} $previewWrapper - A wrapper for the section the preview will be rendered in, renderPreview is used for thumbnails, zoom, and template selection preview
 * @param {Object} embroideryData - If supplied will render a preview based on it, otherwise will use global embroidery data preview
 * @returns {boolean} - if the placement group had any components referencing it
 */
function renderPreview(placementData, $previewWrapper, embroideryData) {
    let data = embroideryData || store.export.data;
    let $contentWrapper = $('.preview-content', $previewWrapper);
    let $previewLabel = $('.preview-label', $previewWrapper);
    let positionMapping = {
        center: '.preview-slot-center',
        L08: '.preview-slot-top',
        L09: '.preview-slot-bottom',
        L10: '.preview-slot-left',
        L11: '.preview-slot-right'
    };

    let textSizeMap = {
        'position-top': 1.7,
        'position-bottom': 1.7,
        'position-left': 1,
        'position-right': 1
    };

    let classMapping = {
        center: 'position-center',
        L08: 'position-top',
        L09: 'position-bottom',
        L10: 'position-left',
        L11: 'position-right'
    };

    $contentWrapper.find('.preview-slot').empty().removeClass('has-content');
    $previewLabel.text(placementData.valueDesc);
    $contentWrapper.removeAttr('data-position');

    // Get all the embroidery components set in this placement
    let components = data.filter(component => {
        let placement = component.componentAttributes.find(attribute => attribute.attributeValue === placementData.valueId);
        return placement;
    });

    let y = 0;
    let x = 0;

    if (components.length) {
        // For each component that was set for this placement
        $contentWrapper.find('.preview-slot').removeClass('has-content').empty();
        components.forEach(component => {
            let $previewEl = $('<div/>').addClass('preview-content-row');

            if (component.component === 'TEXT') {
                // Text component is always placed in the center wrapper
                $contentWrapper.find(positionMapping.center).addClass('has-content').append($previewEl);
            } else {
                // Inject element in the appropriate wrapper depending on positioning option
                let positioning = component.componentAttributes.find(attribute => attribute.componentAttribute === 'POSITIONING');
                // Default to above text position until user selects a position
                if (positioning && positionMapping[positioning.attributeValue]) {
                    $contentWrapper.attr('data-position', classMapping[positioning.attributeValue]).find(positionMapping[positioning.attributeValue]).addClass('has-content').append($previewEl);
                } else {
                    $contentWrapper.attr('data-position', classMapping.L08).find('.preview-slot-top').addClass('has-content').append($previewEl);
                }
            }

            // For each attribute of this component (color, text etc)
            // Add special classes and other data on a component DOM element
            component.componentAttributes.forEach(attribute => {
                let type = attribute.componentAttribute.toLowerCase();
                var $img;
                var url;

                switch (type) {
                    case 'freetext':
                        $previewEl.text(attribute.attributeValue);
                        break;

                    case 'font':
                        $previewEl.attr('data-font', attribute.attributeValue);
                        break;

                    case 'color':
                        $previewEl.css('color', `#${attribute.valueHexCode}`);
                        break;

                    case 'design':
                        // Set the url prefix for loading stock or flag images
                        url = $('.preview-resources').data(`url-${component.component.toLowerCase()}`);

                        $img = $('<img/>').attr('src', url + attribute.attributeValue + '.png');
                        $previewEl.append($img);
                        break;

                    case 'positioning':
                        $previewEl.addClass(`position-${attribute.attributeValue.toLowerCase()}`);
                        break;

                    case 'size':
                        $previewEl.addClass(`size-${attribute.attributeValue.toLowerCase()}`);
                        break;

                    case 'logo name':
                        url = attribute.previewUrl;

                        if (url) {
                            $img = $('<img/>').attr('src', url);
                            $previewEl.append($img);
                        }

                        break;

                    case 'placement':
                    default:
                        break;
                }
            });
        });

        // Count occupied 'rows' since components are inline and can be maximum of 3 components vertically
        $('.preview-slot-row', $contentWrapper).each(function () {
            if ($(this).find('.has-content').length) {
                y++;
            }
        });

        // Count elements on the horizontal axis for each row and take into account greatest value
        let middleRowComponents = 0;
        $('.preview-slot-middle-wrap .preview-slot', $contentWrapper).each(function () {
            let $this = $(this);
            if ($this.hasClass('has-content')) {
                if ($this.hasClass('preview-slot-center')) {
                    // All text components should count as 1
                    middleRowComponents++;
                } else {
                    middleRowComponents += $this.children().length;
                }
            }
        });

        let scaleComponents = function () {
            x = Math.max($('.preview-slot-top', $contentWrapper).children().length, $('.preview-slot-bottom', $contentWrapper).children().length, middleRowComponents);

            let wrapperWidth = $contentWrapper[0].getBoundingClientRect().width;
            let wrapperHeight = $contentWrapper[0].getBoundingClientRect().height;

            let componentWidth = wrapperWidth / Math.max(x, y);
            let componentHeight = wrapperHeight / Math.max(x, y);

            // Scale all components except text components
            $('.preview-slot:not(.preview-slot-center) .preview-content-row', $contentWrapper).css({
                width: componentWidth,
                height: componentHeight
            });

            // Scale text components wrapper since all text components are grouped together
            $('.preview-slot-center', $contentWrapper).css({
                width: componentWidth * (textSizeMap[$contentWrapper.attr('data-position')] || 1)
            });
        };

        scaleComponents();

        // Handle viewport resizing
        $(window).off('resize', scaleComponents).on('resize', scaleComponents);

        return true;
    }

    // Placement has no component present
    return false;
}

/**
 * Animates the Text tab intro
 */
function textAreaAnimation() {
    if (!$('.animatedTextTab').hasClass('visible')) {
        $(function () {
            setTimeout(() => {
                $('.animatedTextTab').addClass('visible');
            }, 300);
        });
    }
}

/**
 * Rerenders all the embroidery placements previews
 */
function renderThumbnailPreview() {
    // For each placement thumbnail
    store.globals.placementsData.forEach(placementData => {
        let $previewWrapper = $(`.placement-preview-thumbs[data-location="${placementData.valueId}"]`);
        renderPreview(placementData, $previewWrapper);
    });
}

/**
 * Opens the location zoomed in view
 * @param {string} locationId - the id of the selected placement
 */
function triggerZoomedView(locationId) {
    if (locationId !== undefined) {
        let placementData = store.globals.placementsData.find(placement => placement.valueId === locationId);

        store.globals.selectedPlacement = placementData;
        $('.image-section').addClass('display-preview-image');
        renderPreview(placementData, $('.placement-preview-big'));
    } else {
        $('.image-section').removeClass('display-preview-image');
    }
}

/**
 * Updates the thumbnail previews and large preview if user has it open
 */
function syncPreviews() {
    // Update preview when an embroidery value changes
    renderThumbnailPreview();

    // If the large embroidery preview is open and visible, keep it updated for the selected placement
    if ($('.image-section').hasClass('display-preview-image')) {
        renderPreview(store.globals.selectedPlacement, $('.placement-preview-big'));
    }
}

/**
 * Show rep message when there are new logos
 */
function showLogoRep() {
    const customLogos = $('.embroidery-section button.custom-logo-button');
    const newLogos = customLogos.filter((i, el) => $(el).data('status') === 0) || [];
    if (newLogos.length > 0 || customLogos.length === 0) {
        $('.type-logo-selection-representative-message').removeClass('d-none');
    }
}

/**
 * Updates the character count for the text input field
 * @param {Object} $el - the input field jQuery object
 */
function updateCharCount($el) {
    var currentLength = $el.val().length;
    $el.parents('.form-group').find('.counter-current').text(currentLength);
}

/**
 * Runs custom code for each embroidery component form field, on change, since most are different types of fields
 */
let updateField = {
    freetext: function (uiField, value) {
        let $el = uiField.$el;
        $el.val(value);
        let componentId = $el.data('component-id');

        updateCharCount($el);

        var pattern = /^[a-zA-Z0-9,.!#$%&*()+/"_'-]+[a-zA-Z0-9,.!#$%&*()+/"_'\s-]*$/;
        if (!pattern.test(value)) {
            uiField.$wrapper.addClass('issue-error');
            var errorMsg = value === '' ? $el.data('missing-error') : $el.data('pattern-mismatch');
            if (uiField.$wrapper.children('figure').length) {
                uiField.$wrapper.children('.error-instruct').text(errorMsg);
            } else {
                let errorEl = $('<figure></figure>').text(errorMsg).addClass('error-instruct');
                uiField.$wrapper.append(errorEl);
            }
            store.state.setComplete('FREETEXT', $el.data('componentId'), false);
            $(`.selection-box-content-font[data-component-id=${componentId}]`).children('.selection-box-content-font-output').text();
        } else {
            uiField.$wrapper.removeClass('issue-error');
            uiField.$wrapper.children('.error-instruct').remove();
            store.state.setComplete('FREETEXT', $el.data('componentId'), true);
            $(`.selection-box-content-font[data-component-id=${componentId}]`).children('.selection-box-content-font-output').text(value);
        }
    },
    text: function (uiField, value) {
        let $el = uiField.$el;
        $el.val(value);
    },
    placement: function (uiField, value) {
        let $el = uiField.$el;
        if (value === '') {
            $el.removeClass('selected');
            store.state.setComplete('PLACEMENT', $el.data('componentId'), false);
        } else {
            $el.removeClass('selected').filter(`[data-value="${value}"]`).addClass('selected');
            store.state.setComplete('PLACEMENT', $el.data('componentId'), true);
        }
    },
    font: function (uiField, value) {
        let $el = uiField.$el;
        let $fieldContext = $el.parents('.text-selection-font');

        $('.selection-box', $fieldContext).removeClass('active');
        if (value === '') {
            $('.selection-box-label', $fieldContext).removeClass('selected');
            $('.selected-label', $fieldContext).empty();
            store.state.setComplete('FONT', $el.data('componentId'), false);
        } else {
            let $selected = $el.filter(`[data-value="${value}"]`);
            $('.selection-box-label', $fieldContext).attr('data-font', value).addClass('selected');
            $('.selected-label', $fieldContext).text($('.selection-box-content-font-name', $selected).text());
            store.state.setComplete('FONT', $el.data('componentId'), true);
        }
    },
    color: function (uiField, value, attributeData) {
        let $el = uiField.$el;
        let $fieldContext = $el.parents('.text-selection-color');
        $('.selection-box', $fieldContext).removeClass('active');

        if (value === '') {
            $('.selection-box-label', $fieldContext).removeClass('selected');
            $('.selected-label', $fieldContext).empty();
            store.state.setComplete('COLOR', $el.data('componentId'), false);
        } else {
            let $selected = $el.filter(`[data-value="${value}"]`);
            $('.selection-box-label', $fieldContext).addClass('selected');
            $('.selected-label', $fieldContext).html($selected.html());
            store.state.setComplete('COLOR', $el.data('componentId'), true);

            let color = attributeData.valueHexCode;
            if (color && store.globals.productColor) {
                let validContrast = Contrast.getValidContrast(store.globals.productColor, color);
                if (!validContrast) {
                    store.state.setWarning($el.data('componentId'), uiField, store.resources.errors.colorIssue);
                }
            }
        }
    },
    design: function (uiField, value) {
        let $el = uiField.$el;
        if (value === '') {
            $el.removeClass('selected');
            store.state.setComplete('DESIGN', $el.data('componentId'), false);
        } else {
            $el.removeClass('selected').filter(`[data-value="${value}"]`).addClass('selected');
            store.state.setComplete('DESIGN', $el.data('componentId'), true);
        }
    },
    positioning: function (uiField, value) {
        let $el = uiField.$el;
        let $fieldContext = $el.parents('.designs-position');
        $('.selection-box', $fieldContext).removeClass('active');
        if (value === '') {
            $('.selection-box-label', $fieldContext).removeClass('selected');
            $('.selected-label', $fieldContext).empty();
            store.state.setComplete('POSITIONING', $el.data('componentId'), false);
        } else {
            let $selected = $el.filter(`[data-value="${value}"]`);
            $('.selection-box', $fieldContext).attr('data-value', value);
            $('.selection-box-label', $fieldContext).addClass('selected');
            $('.selected-label', $fieldContext).text($selected.text());
            store.state.setComplete('POSITIONING', $el.data('componentId'), true);
        }
    },
    size: function (uiField, value) {
        let $el = uiField.$el;
        if (value === '') {
            $el.prop('checked', false);
        } else {
            $el.filter(`[value="${value}"]`).prop('checked', true);
        }
        store.state.setComplete('SIZE', $el.data('componentId'), value !== '');
    },
    logo_name: function (uiField, fileName) {
        let $el = uiField.$el;
        $el.removeClass('selected');

        if (fileName) {
            $el.filter(`[data-value="${fileName}"]`).addClass('selected');
            $(`.selected-file-name[data-component-id="${$el.data('componentId')}"]`).text(fileName);
        }

        store.state.setComplete('LOGO NAME', $el.data('componentId'), !!fileName);
    },
    logo_number: function (uiField, guid) {
        let $el = uiField.$el;

        store.state.setComplete('LOGO NUMBER', $el.data('componentId'), !!guid);
    }
};

/**
 * Updates pricing information for embroidery
 */
function updateEmbroideryPricing() {
    store.globals.pricing.totalEmbroideryPrice = store.globals.pricing.singleEmbroideryPrice * store.globals.appliedToQty;
    store.globals.pricing.totalEmbroideryPriceFormatted = store.globals.pricing.currencySymbol + store.globals.pricing.totalEmbroideryPrice.toFixed(2);
    store.globals.pricing.embrSubTotal = store.globals.pricing.product.value + store.globals.pricing.singleEmbroideryPrice;
    store.globals.pricing.embrSubTotalFormatted = store.globals.pricing.currencySymbol + store.globals.pricing.embrSubTotal.toFixed(2);
    store.globals.pricing.embrTotal = store.globals.pricing.embrSubTotal * store.globals.appliedToQty;
    store.globals.pricing.embrTotalFormatted = store.globals.pricing.currencySymbol + store.globals.pricing.embrTotal.toFixed(2);
}

/**
 * Checks the saved template data vs the embroidery data
 * Components/attributes that aren't defined in original data will be removed from saved template
 * The template will load but only valid attributes will autocomplete
 * @param {Object} controlData - The current embroidery configuration for this product
 * @param {Object} savedData - The template saved data
 * @returns {Object} - the template data validated against the current embroidery configuration for this product
 */
function validateEmbroidery(controlData, savedData) {
    // A copy of saved template data with invalid attributes removed
    let validatedData = {
        data: [],
        countMap: {}
    };

    // Save only the component types still offered for embroidery (text, flag etc)
    if (typeof savedData.data === 'string') {
        savedData.data = JSON.parse(savedData.data);
    }

    savedData.data.forEach(componentData => {
        if (controlData[componentData.component]) {
            if (validatedData.countMap[componentData.component]) {
                validatedData.countMap[componentData.component]++;
            } else {
                validatedData.countMap[componentData.component] = 1;
            }

            validatedData.data.push(cloneDeep(componentData));
        }
    });

    for (let i = 0; i < validatedData.data.length; i++) {
        const templateComponent = validatedData.data[i];

        // Check every attribute saved for this component vs the control data
        for (let j = 0; j < templateComponent.componentAttributes.length; j++) {
            const attribute = templateComponent.componentAttributes[j];
            const controlAttribute = controlData[templateComponent.component].componentAttributes[attribute.componentAttribute];

            // Check the attribute value saved exists in the control data, else remove it
            if (!controlAttribute || (controlAttribute && controlAttribute.optionValues && !controlAttribute.optionValues.find(attributeData => attributeData.valueId === attribute.attributeValue))) {
                templateComponent.componentAttributes.splice(j, 1);
                j--;
            }
        }
    }

    return validatedData;
}

/**
 * Shows the selected location in the image section
 */
function highlightLocation() {
    let activePlacements = [];

    // Get all components that have placements defined already
    store.export.data.forEach(component => {
        let placementDefined = component.componentAttributes.find(attribute => attribute.componentAttribute === 'PLACEMENT');
        if (placementDefined) {
            activePlacements.push(placementDefined);
        }
    });

    // Reset the active class
    let $circles = store.cache.$imagePlacements.find('.image-selection-circle').removeClass('active');
    let $previews = $('.placement-preview-thumbs').removeClass('active');
    $('.placement-preview-thumbs').removeClass('d-flex');

    // Add active class for all placements corresponding to a component
    activePlacements.forEach(placement => {
        $previews.filter(`[data-location="${placement.attributeValue}"]`).addClass('active');
        $circles.filter(`[data-location="${placement.attributeValue}"]`).addClass('active');
        $('.placement-preview-thumbs.active.d-none').addClass('d-flex');
        $('.placement-preview-thumbs.active.d-none').siblings('.d-none').addClass('d-flex');
    });
}

/**
 * Removes the current embroidery forms and data and initialises new ones based on data from the saved template
 * @param {Object} templateData - The template embroidery data after it has been validated
 */
function mergeTemplate(templateData) {
    // Run a loop through template components and dump all the old components present in the page
    templateData.data.forEach(componentData => {
        let existingComponents = store.export.data.filter(x => x.component === componentData.component);
        if (existingComponents.length) {
            existingComponents.forEach(component => {
                store.export.removeComponent(component.uid);

                // Don't remove HTML of components that don't get rendered through js and are static
                let model = store.cache.models[component.component];
                if (model) {
                    store.state.remove(component.uid);
                }
            });
        }
    });

    // Adds components after all components were cleared in previous step
    // Needs separation to not remove the components being added in the same cycles
    templateData.data.forEach(componentData => {
        // Add a clean new component of this template type
        let newComponent = store.export.addComponent(store.globals.componentsData[componentData.component]);
        // Render it
        store.state.render(newComponent);
        // Update it with saved values from template
        newComponent.updateAll(componentData.componentAttributes);
    });
}

/**
 * Populates the 'select template' select with options representing the templates saved
 */
function loadTemplatesSelectorOptions() {
    let $templatesSelector = $('#templateSelector');
    let $templateSelectorButton = $('[data-component-template="templateSelector"]');

    if (store.globals.userTemplates && store.globals.userTemplates.length) {
        $templatesSelector.find('.selection-box-content').empty();

        store.globals.userTemplates.forEach(savedTemplate => {
            $templatesSelector.find('.selection-box-content').append(
                $templateSelectorButton.clone().removeAttr('data-component-template').data('templateId', savedTemplate.id).text(savedTemplate.name)
            );
        });
    }
}

/**
 * Checks localstorage for expired templates and removes them
 * @returns {Object} templatesData - the remaining valid templates
 */
function validateStoredTemplates() {
    // If saved templates are available for the guest user
    let templatesData = JSON.parse(window.localStorage.getItem('savedEmbroideryTemplates'));

    // Check each template's expiration data
    for (let i = 0; i < templatesData.length; i++) {
        const template = templatesData[i];
        if (!template.expiration || (new Date()).getTime() > template.expiration) {
            templatesData.splice(i, 1);
            i--;
        }
    }

    // If no templates remain clean the localstorage or update localstorage and load them in embroidery
    if (templatesData.length) {
        window.localStorage.setItem('savedEmbroideryTemplates', JSON.stringify(templatesData));
    } else {
        window.localStorage.removeItem('savedEmbroideryTemplates');
    }

    return templatesData;
}

/**
 * Handles storing templates into localstorage for guest users
 * @param {Object} templateData - the embroidery template data
 */
function storeTemplate(templateData) {
    let savedTemplatesJSON = window.localStorage.getItem('savedEmbroideryTemplates');
    let savedTemplates;

    // Set localstorage template data expiration to 24 hours
    templateData.expiration = (new Date()).getTime() + store.globals.templateExpirationTime;

    if (savedTemplatesJSON) {
        savedTemplates = JSON.parse(savedTemplatesJSON);
        let exists = savedTemplates.findIndex(template => template.name === templateData.name);

        if (~exists) {
            savedTemplates[exists] = templateData;
        } else {
            savedTemplates.push(templateData);
        }

        window.localStorage.setItem('savedEmbroideryTemplates', JSON.stringify(savedTemplates));
    } else {
        savedTemplates = [templateData];
        window.localStorage.setItem('savedEmbroideryTemplates', JSON.stringify(savedTemplates));
    }

    store.globals.userTemplates = savedTemplates;
    store.cache.$modal.data('embroidery').templates = savedTemplates;
    loadTemplatesSelectorOptions();
}

/**
 * Push template data to backend
 * @param {Object} templateData - the template data
 */
function postTemplate(templateData) {
    let csrf = $('#csrf', store.cache.$modal);
    let postData = {};
    postData[csrf.attr('name')] = csrf.val();
    postData.embroideryData = JSON.stringify(templateData);

    $.ajax({
        url: store.resources.url.saveTemplate,
        method: 'POST',
        data: postData,
        success: function (response) {
            if (response && response.success && response.list) {
                // Update templates list and template selector with new options
                store.globals.userTemplates = response.list.map(template => JSON.parse(template));
                loadTemplatesSelectorOptions();
            } else {
                $('.add-embroidery-error', store.cache.$modal).text(response.message || store.resources.errors.generalSubmit).show();
            }
        },
        error: function (response) {
            $('.add-embroidery-error', store.cache.$modal).text(response.message || store.resources.errors.generalSubmit).show();
        }
    });
}

/**
 * Decides where to push saved template data based on user auth status
 * @param {Object} templateData - the embroidery template data
 */
function saveTemplate(templateData) {
    if (store.cache.$modal.data('isauthenticated')) {
        postTemplate(templateData);
    } else {
        storeTemplate(templateData);
    }
}

/**
 * Saves a template
 * @param {string} templateName - The name the template will be saved as
 */
function setTemplate(templateName) {
    let templateData = {
        data: cloneDeep(store.export.data),
        id: Math.random().toString(36).slice(2),
        productColor: store.globals.productColor,
        backgroundImage: store.globals.backgroundImage,
        garmentType: store.globals.embrodieryConfiguration.garmentType,
        garmentCategory: store.globals.embrodieryConfiguration.garmentCategory,
        name: templateName
    };

    saveTemplate(templateData);

    // Enables the templates section if user didn't have any templates previously
    store.cache.$modal.find('.no-templates').removeClass('no-templates');
}

/**
 * Disables/enables placements according to design component limit rule
 */
function setPlacementsLimits() {
    designElements.forEach(designComponent => {
        let section = store.state.sections[designComponent];
        if (!section) {
            return;
        }
        let forms = section.getForms();

        // Get all forms from all the sections corresponding to 'design elements'
        forms.forEach(form => {
            let placementStep = form.steps.find(step => step.id === 'PLACEMENT');

            if (placementStep) {
                placementStep.$el.each(function () {
                    // Disable each placement button if corresponding placement data has 'hasDesignElement' flag set
                    // and is not already selected
                    let placementId = $(this).data('value');
                    let placementGlobalData = store.globals.placementsData.find(placement => placement.valueId === placementId);
                    if (!$(this).hasClass('selected')) {
                        $(this).toggleClass('placement-unavailable', placementGlobalData.hasDesignElement);
                    }
                });
            }
        });
    });
}

/**
 * Limits placement options if one component type from 'designElements' array was selected on placement
 */
function setPlacementsAvailability() {
    store.globals.placementsData.forEach(placement => {
        placement.hasDesignElement = false;
    });

    // Check each completed option and if placement was chosen and is design option, set hasDesignElement flag on that placement
    store.export.data.forEach(componentData => {
        if (~designElements.indexOf(componentData.component)) {
            let componentPlacement = componentData.getAttribute('PLACEMENT');
            if (componentPlacement) {
                let placementGlobal = store.globals.placementsData.find(placement => placement.valueId === componentPlacement.attributeValue);

                if (placementGlobal) {
                    placementGlobal.hasDesignElement = true;
                }
            }
        }
    });

    setPlacementsLimits();
}

/**
 * Runs the code necessary to apply an embroidery template, validates template data, replaces and updates the view
 * @param {Object} template - The template embroidery data before it has been validated
 */
function applyTemplate(template) {
    if (template) {
        store.cache.$imageSection.spinner().start();
        $('.template-contrast-error').addClass('d-none');
        let validTemplateData = validateEmbroidery(store.cache.$modal.data('embroidery').components, template);

        mergeTemplate(validTemplateData);

        if (store.state.sections.TEXT.hasWarning) {
            $('.template-contrast-error').removeClass('d-none');
        }

        highlightLocation();
        syncPreviews();
        setPlacementsAvailability();

        store.cache.$imageSection.spinner().stop();
    }
}

/**
 * Check embroidery before adding to cart
 * @param {jquery} elem - DOM container for a given add to cart button
 * @return {boolean} embroidery checked or not/not present on page
 */
function checkEmbroiderySelection(elem) {
    return elem.closest('.product-detail').find('[id*="embroiderySelection"]:checked').length > 0;
}

/**
 * Shows the layer for the selected option (text, stock etc)
 * @param {Object} sectionType - identificator for the section
 */
function showOptionSection(sectionType) {
    if (!$('.section-common-selection:visible').length) {
        store.cache.$sectionAll.hide();
        store.cache.$sectionCommon.fadeIn();
    }

    if (!$('.embroidery-selection-sidebar:visible').length) {
        store.cache.$sidebar.fadeIn();
    }

    store.cache.$modalBody.attr('activesection', sectionType);
    store.cache.$optionsToggle.removeClass('active').filter(`[data-section="${sectionType}"]`).addClass('active');
    store.cache.$typeAll.fadeOut(0).filter(`[data-section="${sectionType}"]`).fadeIn();
    store.state.currentSection = sectionType;

    var current = store.state.sections[sectionType];
    if (current) {
        store.cache.$sectionError.toggleClass('invisible', current.valid || current.untouched);
    } else {
        store.cache.$sectionError.addClass('invisible');
    }

    if (sectionType === 'TEXT') {
        setTimeout(function () {
            $('#text-selection-input-line-1_1').focus();
        }, 100);
    }
}

/**
 * Renders the summary of added embroideries on the summary page and component footer
 */
function updateSummaryTotals() {
    let currentComponents = store.export.data;
    let completed = [];
    let mappedSummary = {};
    let flagSelectionSummary = {};
    // Filter all the embroidery components that are complete
    currentComponents.forEach(component => {
        let componentForm = store.state.getForm(component.uid);

        if (componentForm && componentForm.complete) {
            completed.push(component);
        }
    });

    // Parse them into an object that has the count of components of same type
    if (completed.length) {
        completed.forEach(componentData => {
            if (mappedSummary[componentData.component] && componentData.component !== 'FLAG') {
                mappedSummary[componentData.component]++;
            } else {
                mappedSummary[componentData.component] = 1;
                if (componentData.component === 'FLAG') {
                    flagSelectionSummary[componentData.uid] = 1;
                }
            }
        });
    }

    // Reset the wrapper content AND embroidery price
    store.globals.pricing.singleEmbroideryPrice = 0;
    $('.list-summary', store.cache.$embroiderySummaryList).empty();

    let keys = Object.keys(mappedSummary);

    if (keys.length) {
        // Get only one dom model object, template included multiple times and will return multiple dom nodes wrongly
        let $model = store.cache.$embroiderySummaryList.find('[data-component-template="embroiderySummaryList"] .common-selection-summary-item').eq(0);

        let runningTotal = 0;
        let smallFlagPrice = $('.component-price').data('price-smallflag').sales.value;
        let largeFlagPrice = $('.component-price').data('price-largeflag').sales.value;

        // Render each component type into a new line with the components count
        keys.forEach(key => {
            let $item = $model.clone().removeClass('d-none');
            let label = store.cache.$embroiderySummaryList.data(key.toLowerCase());

            let price = 0;
            let finalComponentPrice = 0;
            let finalCount = 0;
            if (key === 'FLAG') {
                let flagKeys = Object.keys(flagSelectionSummary);
                flagKeys.forEach(flagKey => {
                    let flagSelected = $('input[data-component-id=' + flagKey + ']:checked').val();
                    if (flagSelected === 'L') {
                        price += largeFlagPrice;
                    } else {
                        price += smallFlagPrice;
                    }
                });
                finalComponentPrice = price;
                finalCount = flagKeys.length;
            } else {
                let priceData = $('.component-price').data('price-' + key.toLowerCase());

                price = (priceData && priceData.sales && priceData.sales.value) || 0;
                finalComponentPrice = price * mappedSummary[key];
                finalCount = mappedSummary[key];
            }

            // Reduce to 2 decimals
            finalComponentPrice = parseFloat(finalComponentPrice.toFixed(2));

            if ($item && $item.length && label) {
                $('.common-selection-summary-label', $item).text(label + ` (${finalCount})`);
                $('.common-selection-summary-value', $item).text(store.globals.pricing.currencySymbol + finalComponentPrice);
                $('.list-summary', store.cache.$embroiderySummaryList).append($item);
            }
            runningTotal += finalComponentPrice;
        });

        store.globals.pricing.singleEmbroideryPrice = runningTotal;
    }

    updateEmbroideryPricing();
}

/**
 * Shows warning icons on sections and placements if applicable
 */
function parseErrors() {
    // Get the sections with issues
    let sectionsWithIssues = store.state.getSectionsWithIssues();

    // Reset the error class and add it in navigation for all sections with issues
    $('.option-section-toggle').removeClass('issue');
    if (sectionsWithIssues && sectionsWithIssues.length) {
        sectionsWithIssues.forEach(section => {
            $(`.option-section-toggle[data-section="${section.type}"]`).addClass('issue');
        });
    }

    // Each form (line) can have a different placement
    // Get all the forms with issues and push the unique placement value that corresponds to the form
    let placementsWithIssues = [];
    let formsWithIssues = store.state.getFormsWithIssues();
    let contrastWarning = false;
    formsWithIssues.forEach(form => {
        let componentData = store.export.data.find(component => component.uid === form.id);
        let placement = componentData.componentAttributes.find(attribute => attribute.componentAttribute === 'PLACEMENT');
        if (placement && !~placementsWithIssues.indexOf(placement.attributeValue)) {
            placementsWithIssues.push(placement.attributeValue);
        }

        let colorAttribute = form.steps.find(attribute => attribute.id === 'COLOR');
        if (colorAttribute && colorAttribute.warning.state) {
            contrastWarning = true;
        }
    });

    // Push an error message about constrast on the main image layer
    // Must be unique and persist as long as one field has contrast warning
    $('.contrast-warning-wrapper', store.cache.$modal).toggleClass('d-none', !contrastWarning);

    // Reset errors and show the errors on placements that have issues
    store.cache.$locationMarkers.removeClass('issue');
    placementsWithIssues.forEach(placementValue => {
        $(`.image-selection-circle[data-location="${placementValue}"]`).addClass('issue');
    });

    // Shows warning icon on hamburger icon (mobile embroidery close)
    $('.embroidery-mobile-close', store.cache.$modal).toggleClass('issue', !!sectionsWithIssues.length);
}

/**
 * Warns user of the activation of the now required positioning field (under a different tab that he's viewing)
 */
function showPositionWarningModal() {
    let text = $('.dynamic-text', store.cache.$positionOverlay).data('text');
    $('.dynamic-text', store.cache.$positionOverlay).text(replaceTags(positionWarningData, text));
    store.cache.$positionOverlay.show();
}

/**
 * Checks if a text component and a design component are in the same placement
 * Triggers validation and events to alert the user to complete additional fields
 */
function handleDesignOverText() {
    store.export.data.forEach(componentData => {
        // Check if component is type 'design component'
        if (designElements.includes(componentData.component)) {
            let placementAttribute = componentData.componentAttributes.find(attribute => attribute.componentAttribute === 'PLACEMENT');

            if (placementAttribute) {
                // Text component is in the same placement flag
                let textInPlace = store.export.data.find(component => {
                    return component.component === 'TEXT' && component.componentAttributes.find(attribute => attribute.componentAttribute === 'PLACEMENT' && attribute.attributeValue === placementAttribute.attributeValue);
                });

                let section = store.state.sections[componentData.component];
                let form = section && section.getForm(componentData.uid);
                if (form) {
                    let positioning = form.steps.find(step => step.id === 'POSITIONING');
                    let positioningData = componentData.componentAttributes.find(attribute => attribute.componentAttribute === 'POSITIONING');

                    // If text component present set positioning field as required
                    if (textInPlace) {
                        positioning.required = true;
                        if (positioning.$wrapper && positioning.$wrapper.length) {
                            positioning.$wrapper.removeClass('d-none');
                        }
                        positionWarningData.designElement = componentData.component.toLowerCase();
                        positionWarningData.designElement = positionWarningData.designElement.charAt(0).toUpperCase() + positionWarningData.designElement.slice(1);
                        positionWarningData.placement = (placementAttribute.webDisplayValue || placementAttribute.valueDesc).toLowerCase();
                        positionWarningData.position = ((positioningData && (positioningData.webDisplayValue || positioningData.valueDesc)) || store.resources.labels.positionDefaultText).toLowerCase();
                    } else {
                        positioning.required = false;
                        if (positioning.$wrapper && positioning.$wrapper.length) {
                            positioning.$wrapper.addClass('d-none');
                        }
                        positioning.clearError();
                    }

                    form.updateFieldsAvailability();

                    // If user is completing text component, highlight missing positioning field under design element tab
                    if (store.state.currentSection === 'TEXT') {
                        section.validateSectionFields();

                        // If text and design present and positioning hasn't been chosen, alert the user
                        if (positioning.required && !positioningData) {
                            showPositionWarningModal();
                        }
                    }
                }
            }
        }
    });
}

/**
 * Check if at least one Embroidery Section is complete
 * @return {boolean} embroidery section complete
 */
function activeEmbroiderySection() {
    var active = false;

    store.export.data.forEach(componentData => {
        if (componentData.component !== 'COMMENTS' && componentData.componentAttributes.length !== 0) {
            active = true;
        }
    });

    return active;
}

/**
 * Show Are You Sure Overlay
 * @param {string} id - the reference id for the component line being deleted
 * @param {function} callbackAction - custom action fired after yes pressed
 */
function showAreYouSureOverlay(id, callbackAction) {
    store.cache.$areYouSureOverlay.show();

    store.cache.$areYouSureOverlay.off('click', '.dismiss-action').on('click', '.dismiss-action', function () {
        store.cache.$areYouSureOverlay.hide();
    });

    store.cache.$areYouSureOverlay.off('click', '.confirm-action').on('click', '.confirm-action', function () {
        let type = store.export.data.find(componentData => componentData.uid === id).component;
        let ofType = store.export.data.filter(componentData => componentData.component === type);
        let count = ofType.length;
        $('.logo-process-error').text('');
        // If only one line exists reset it rather than delete
        if (count === 1) {
            // Reset the form validator to first step
            let line = store.state.getForm(id);
            line.reset();
            // Empty the data for form, and trigger fields update with empty values
            store.export.getComponent(id).reset();
        } else {
            store.export.delete(id);
            store.state.deleteForm(id);
            $(`.embroidery-component-line[data-component-id="${id}"]`).remove();
        }

        let activeForms = store.state.sections[type].getForms();

        activeForms.forEach((form, i) => {
            form.$el.renderTemplate({
                lineCount: i + 1,
                addLine: store.cache.$resources.data(`${type.toLowerCase()}-addline-${i}`)
            });

            // Need to refresh all id's when deleting a component, cases can exist when a remaining component has the same id
            // as the new one from 'count' match
            // Keep id's and for attributes unique with line count suffix
            let $tagsWithID = form.$el.find('[id], [for]');
            $tagsWithID.each(function () {
                let attribute = $(this).attr('id') ? 'id' : 'for';
                let idPrefix = $(this).attr(attribute).split('_')[0];
                $(this).attr(attribute, `${idPrefix}_${i}`);
            });

            // Update name attribute on radios to avoid duplicates
            let $radios = form.$el.find('input[type="radio"]');
            $radios.each(function () {
                $(this).attr('name', `${type}-radio_${i}`);
            });
        });

        if (callbackAction && typeof callbackAction === 'function') {
            callbackAction();
        }

        setPlacementsAvailability();

        highlightLocation();
        syncPreviews();
        triggerZoomedView();
        updateSummaryTotals();

        if (activeForms[0].untouched && !activeEmbroiderySection()) {
            $('.button-go-to-review').toggleClass('disabled', true);
        }
        store.cache.$areYouSureOverlay.hide();
    });
}

/**
 * Init added to bag modal
 */
function initAddedToBag() {
    store.cache.$addedModal.on('click', '.btn-continue-shopping', function () {
        store.cache.$addedModal.modal('hide');
    });

    store.cache.$addedModal.on('shown.bs.modal', function () {
        var $carouselContainer = store.cache.$addedModal.find('.add-to-card-modal-carousels');

        // Clone carousel from atc-modal-recommendations slot only
        if ($carouselContainer.length && !$carouselContainer.hasClass('carousels-loaded')) {
            var $sourceCarouselSlot = $('.addToCartModal').first().find('.atc-modal-recommendations-slot');
            var $sourceCarousel = $sourceCarouselSlot.find('.recommendation-carousel-wrapper');
            var $fylCarousel = store.cache.$addedModal.find('.fyl-carousel');

            if ($sourceCarousel.length) {
                $carouselContainer.empty().append($sourceCarousel.clone(true));
                $carouselContainer.addClass('carousels-loaded');
                $carouselContainer.find('.recommends-container').each(function () {
                    $('body').trigger('widget:update', { element: this });
                });
                carousels.addedModalProductsCarousel(store.cache.$addedModal);
            }

            if ($fylCarousel.length) {
                fyl.methods.initFYLCarousels();
            }
        }
    });
}

/**
 * Init summary section
 */
function initSummarySection() {
    store.cache.$modal.on('change', '#summary-template', function () {
        if ($(this).is(':checked')) {
            $('.summary-template-name').show();

            addValidator.set('incompleteTemplateName', $('.template-name-input').val().length === 0);
        } else {
            $('.summary-template-name').hide();
            addValidator.set('incompleteTemplateName', false);
        }
    });

    store.cache.$modal.on('input', '.template-name-input', function () {
        addValidator.set('incompleteTemplateName', $(this).val().length === 0);
    });

    store.cache.$modal.on('click', '.summary-add-comment-button', function () {
        $(this).hide();
        $('.summary-comment-wrapper').show().find('textarea').trigger('input');
    });

    store.cache.$modal.on('click', '#summary-placement', function () {
        addValidator.set('tosCheck', !$(this).prop('checked'));
    });

    store.cache.$modal.on('click', '.button-add-to-cart', function () {
        const onSuccess = function () {
            // Save a template
            if ($('#summary-template').prop('checked') && $('#summary-template-name').val()) {
                setTemplate($('#summary-template-name').val());
            }

            // Clear embroidery data from localStorage after successful add to cart
            embroideryDestroy();

            store.cache.$modal.modal('hide');

            let isProductPage = $('#pdpProductDetails').length > 0;
            let $modal = store.cache.$addedModal;
            if (($modal && $modal.length) && isProductPage) {
                // Product attributes
                let $productImage = $('.emb-added-image', $modal);
                let $color = $('.emb-added-color', $modal);
                let $size = $('.emb-added-size', $modal);
                let $price = $('.emb-added-price', $modal);
                let $qty = $('.emb-added-qty', $modal);

                // Sync modal product image with variant image
                if ($productImage.length && store.globals.embrodieryConfiguration.product) {
                    $productImage.attr('src', store.globals.embrodieryConfiguration.product.image);
                }

                if ($color.length && store.globals.embrodieryConfiguration.product.attributes.COLOR) {
                    $color.text(store.globals.embrodieryConfiguration.product.attributes.COLOR.displayValue.toLowerCase());
                }

                if ($size.length && store.globals.embrodieryConfiguration.product.attributes.SIZE) {
                    $size.text(store.globals.embrodieryConfiguration.product.attributes.SIZE.displayValue.toLowerCase());
                }

                if ($price.length) {
                    $price.text(`${store.globals.embrodieryConfiguration.product.price.formatted} ${store.resources.labels.each}`);
                }

                if ($qty.length && store && store.globals.quantity) {
                    $qty.text(store.globals.quantity);
                }

                // Render the embroidery components summary in the added modal
                let $list = $('.added-component-list', $modal);
                let $wrapperModel = $('[data-component-template="addedComponentSummary"] .component-item', $modal);
                let $lineModel = $('[data-component-template="addedComponentSummaryLine"] .attribute-item', $modal);
                let componentCount = {};

                $list.empty();
                store.export.data.forEach(componentData => {
                    // Count the same type of components
                    if (componentCount[componentData.component] === undefined) {
                        componentCount[componentData.component] = 1;
                    }

                    if (componentData.component !== 'COMMENTS' && componentData.componentAttributes.length) {
                        let $wrapper = $wrapperModel.clone();

                        // Add first line for price
                        let componentPrice = $('.component-price').data(`price-${componentData.component.toLowerCase()}`);

                        // Flag pricing depends on size
                        if (componentData.component === 'FLAG') {
                            let size = componentData.componentAttributes.find(attribute => attribute.componentAttribute === 'SIZE');
                            componentPrice = $('.component-price').data(`price-${size.valueDesc.toLowerCase()}flag`);
                        }

                        // Push line with price
                        if (componentPrice) {
                            let $line = $lineModel.clone();
                            let label = store.resources.labels.price;

                            $('.added-summary-line-label', $line).text(label);
                            $('.added-summary-line-value', $line).text(componentPrice.sales.formatted);

                            $wrapper.find('.component-item-line').append($line);
                        }

                        // Render all other attributes
                        componentData.componentAttributes.forEach(attribute => {
                            // Skip the label for Logo number
                            if (attribute.componentAttribute !== 'LOGO NUMBER') {
                                let $line = $lineModel.clone();
                                // Retrieve labels by component type and attribute type since label is different for same attribute on different components
                                // Ex 'Stock design', 'Flag design' for DESIGN attribute
                                let label = store.resources.labels[`${componentData.component}-${attribute.componentAttribute}`];

                                // Default to common attribute label
                                if (!label) {
                                    label = store.resources.labels[attribute.componentAttribute];
                                }

                                if (label) {
                                    // Add count to label if applicable (Ex: 'Stock 1')
                                    label = label.replace('{0}', componentCount[componentData.component]);

                                    $('.added-summary-line-label', $line).text(label);
                                    $('.added-summary-line-value', $line).text(attribute.valueDesc || attribute.webDisplayValue || attribute.attributeValue);

                                    $wrapper.find('.component-item-line').append($line);
                                }
                            }
                        });

                        componentCount[componentData.component]++;

                        $list.append($wrapper);
                    }
                });

                store.cache.$addedModal.modal('show');
            }
        };

        const onError = function (response) {
            if (response.status === 410) {
                store.cache.$addToCartError.removeClass('d-none').text(store.resources.errors.addToCart);
            }
        };

        store.cache.$addToCartError.addClass('d-none').text('');

        // Trigger add to cart logic from pdp
        var $addToCartBtn;
        if (store.globals.pageContext === 'quickview') {
            $addToCartBtn = $('.product-detail button.add-to-cart-global');
        } else {
            $addToCartBtn = $('.product-detail button.add-to-cart');
        }

        // Check if add-to-cart button exists before triggering
        if ($addToCartBtn.length > 0) {
            // Pass embroidery parameters as second argument to trigger
            var embroideryParams = {
                components: JSON.stringify(store.export.data),
                embQty: window.store.globals.appliedToQty,
                totalQty: window.store.globals.quantity,
                onSuccess: onSuccess,
                onError: onError
            };
            $addToCartBtn.trigger('click', embroideryParams);
        } else {
            // If button doesn't exist (e.g., on cart page after redirect), show error
            store.cache.$addToCartError.removeClass('d-none').text(store.resources.errors.addToCart || 'Unable to add item to cart. Please try again from the product page.');
        }
    });

    store.cache.$modal.on('click', '.button-add-to-cart-item', function () {
        let embQty = window.store.globals.appliedToQty;
        let url = $(this).data('url');

        // Save a template
        if ($('#summary-template').prop('checked') && $('#summary-template-name').val()) {
            setTemplate($('#summary-template-name').val());
        }

        if (url) {
            store.cache.$addToCartError.addClass('d-none').text('');
            $('#embroideryModal .modal-content').spinner().start();

            $.ajax({
                url,
                method: 'POST',
                data: {
                    pid: store.globals.pid,
                    qty: store.globals.quantity,
                    pliuuid: store.globals.pliuuid,
                    components: JSON.stringify(store.export.data),
                    embQty: embQty,
                    totalQty: store.globals.quantity
                },
                success: function (data) {
                    if (data) {
                        embroideryDestroy();
                        location.reload();
                    }
                },
                error: function (response) {
                    $('#embroideryModal .modal-content').spinner().stop();
                    if (response.status === 410) {
                        store.cache.$addToCartError.removeClass('d-none').text(store.resources.errors.updateCart);
                    }
                }
            });
        } else {
            store.cache.$modal.modal('hide');
        }
    });
}

/**
 * Opens the embroidery landing page
 */
function goToLanding() {
    if (store.globals.pageContext !== 'quickview') {
        // Locks background when modal is opened in a product page
        utils.lockBackground(true);
    }
    store.cache.$modalBody.attr('activesection', 'landing');
    store.cache.$sectionAll.hide();
    store.cache.$sectionType.fadeIn();
    store.cache.$sidebar.hide();
}

/**
 * Opens the embroidery apply to qty page
 */
function goToQtySelect() {
    var $selectElement = $('.embroidery-qty-select');
    $selectElement.empty();

    // Build select options
    for (var i = 1; i <= store.globals.quantity; i++) {
        var option = `<option value="${i}">${i}</option>`;
        $selectElement.append(option);
    }

    store.cache.$modalBody.attr('activesection', 'qty-select');
    store.cache.$sectionAll.hide();
    store.cache.$sectionQTY.fadeIn();
    store.cache.$sidebar.hide();
}

/**
 * Opens the summary section or intercepts to save changes to templates if applicable
 */
function goToSummary() {
    store.cache.$sidebar.hide();
    triggerZoomedView();
    store.cache.$modalBody.attr('activesection', 'summary');
    addValidator.update();
    if (store.globals.isCommentBoxExpandable) {
        $('.summary-add-comment-button').hide();
        $('.summary-comment-wrapper').show();
    } else {
        $('.summary-add-comment-button').show();
        $('.summary-comment-wrapper').hide();
    }
    if (store.globals.templateLoaded && !store.globals.isTemplateUntouched) {
        store.cache.$typeAll.hide();
        store.cache.$saveTemplateOverlay.show();
    } else {
        store.cache.$sectionAll.hide();
        store.cache.$sectionSummary.show();

        if (utils.mediaBreakpointDown('md')) {
            // Rerender previews as on mobile they are hidden before summary
            renderThumbnailPreview();
        }

        $('.mobile-modal-header-heading').renderTemplate({
            mobileheading: store.resources.mobileHeading.SUMMARY
        });
    }
}

/**
 * Opens the next section
 */
function showNextSection() {
    let index = store.state.orderedSections.indexOf(store.state.currentSection);

    if (~index && ((index + 1) < store.state.orderedSections.length)) {
        if (store.state.orderedSections[index + 1] === 'TEMPLATE' && !store.globals.userTemplates.length) {
            showOptionSection(store.state.orderedSections[0]);
        } else {
            showOptionSection(store.state.orderedSections[index + 1]);
        }
    } else {
        showOptionSection(store.state.orderedSections[0]);
    }
}

/**
 * Create a list of placement objects with embroideries added to it, based on export data
 * Used when generating previews based on export data (templates, added embroidery data on line item)
 * @param {Array} data - the added embroidery components array
 * @returns {Array} - the placement list that has embroidery assigned to it
 */
function getPlacementList(data) {
    let placements = [];
    data.forEach(component => {
        let placementData = component.componentAttributes.find(attribute => attribute.componentAttribute === 'PLACEMENT');

        if (placementData && !placements.find(placement => placement.valueId === placementData.attributeValue)) {
            placements.push({
                valueId: placementData.attributeValue,
                webDisplayValue: placementData.webDisplayValue,
                valueDesc: placementData.valueDesc
            });
        }
    });

    return placements;
}

/**
 * Generate a preview list based on embroidery export data, follows a strict html template
 * @param {Array|Object} embroideryData - The export data containing the components array, or the components array
 * @param {Object} $wrapper - The wrapper where the preview will be generated
 * @param {Object} backgroundData - background preview data, color and images if available
 */
function loadPreviewList(embroideryData, $wrapper, backgroundData) {
    if ($wrapper && $wrapper.length) {
        let data = typeof embroideryData === 'string' ? JSON.parse(embroideryData) : embroideryData;
        let placements = getPlacementList(data);
        let $model = $('[data-component-template="previewSlot"] .preview-list-slot', $wrapper);
        let $list = $('.embroidery-preview-list', $wrapper);
        $list.empty();

        placements.forEach(placement => {
            let $previewItem = $model.clone();
            $previewItem.attr('data-location', placement.valueId);

            if (backgroundData && backgroundData.image) {
                $('.preview-content', $previewItem).css('background-image', `url(${backgroundData.image.url})`);
            } else if (backgroundData && backgroundData.color) {
                $('.preview-content', $previewItem).css('background-color', backgroundData.color || store.globals.productColor);
            }

            $list.append($previewItem);
            renderPreview(placement, $previewItem, data);
        });
    }
}

/**
 * Duplicates the markup for an embroidery component based on the 'model' markup already present in the page
 * Refreshes the component id on the nodes in the new markup
 * Creates a new instance of the component
 * @param {Object} componentData - the data of the new component
 * @returns {Object} - The jQuery object of the new markup being injected
 */
EmbroideryUi.prototype.render = function (componentData) {
    let componentType = componentData.component;
    let model = store.cache.models[componentType];
    let $componentHTML;

    if (model) {
        $componentHTML = store.cache.models[componentType].find('.embroidery-component-line').clone();
        // Update new component labels with count 'line x' etc
        let count = store.export.data.filter(x => x.component === componentType).length;
        $componentHTML.renderTemplate({
            lineCount: count,
            addLine: store.cache.$resources.data(`${componentType.toLowerCase()}-addline-${count - 1}`)
        });

        // Keep id's and for attributes unique with line count suffix
        let $tagsWithID = $componentHTML.find('[id], [for]');
        $tagsWithID.each(function () {
            let attribute = $(this).attr('id') ? 'id' : 'for';
            let idPrefix = $(this).attr(attribute).split('_')[0];
            $(this).attr(attribute, `${idPrefix}_${count}`);
        });

        // Update name attribute on radios to avoid duplicates
        let $radios = $componentHTML.find('input[type="radio"]');
        $radios.each(function () {
            $(this).attr('name', `${componentType}-radio_${count}`);
        });

        this.sections[componentType].$el.append($componentHTML);
    } else {
        $componentHTML = $(`.embroidery-component-line[data-type="${componentType}"]`);
    }

    // Update the html id's with the new data model id
    $componentHTML.attr('data-component-id', componentData.uid).find('[data-component-id]').attr('data-component-id', componentData.uid);
    this.sections[componentType].registerForm(componentData, $componentHTML);

    return $componentHTML;
};

/**
 * Shows the uploaded image as a thumbnail
 * @param {Object} file - the file blob
 * @param {string} id - the unique id of the component
 */
function showLogoUploadPreview(file, id) {
    $(`.uploader-complete[data-component-id="${id}"]`).attr('src', URL.createObjectURL(file)).removeClass('d-none');
    $(`.uploader-default[data-component-id="${id}"]`).addClass('d-none');
}

/**
 * Toggles Upload logo form on a field
 * @param {*} $el element of a selected logo
 * @param {*} bool true to hide, false to reveal
 */
function toggleUpload($el, bool) {
    var $uploadField = $el.closest('.logo-selection-line').children('.file-upload-wrapper');
    if (bool) {
        $uploadField.css('display', 'none');
    } else $uploadField.css('display', 'block');
}

/**
 * Resets the drag&drop element to the default state when resetting the form
 * @param {string} id - the unique id of the component
 */
function resetLogoUploadPreview(id) {
    let $context = $(`.logo-selection-line[data-component-id="${id}"]`);

    $('.file-upload-logo', $context).removeClass('highlight');
    $('.uploader-complete', $context).attr('src', '').addClass('d-none');
    $('.uploader-default', $context).removeClass('d-none');
}
/**
 * Returns the html list of customer saved logos
 * @returns {Object | boolean} promise - ajax response or false
 */
function getSavedLogos() {
    if (store.resources.url.getLogos) {
        $.spinner().start();
        return $.ajax({
            type: 'GET',
            url: store.resources.url.getLogos,
            success: function () {
                $.spinner().stop();
            }
        });
    }

    return false;
}

/**
 * Resets the drag&drop element to the default state when resetting the form
 * @param {string} id - the unique id of the component
 */
function discardLogoSelection(id) {
    let $context = $(`.logo-selection-line[data-component-id="${id}"]`);
    resetLogoUploadPreview(id);
    $('.file-name', $context).text('');
    $('.confirm-logo-upload').data('uploadData', null);
    $('.img-upload-input', $context).val('');
    $('.uploader-file-error', $context).addClass('d-none');
}

/**
 * Disables running the upload logo logic and the upload button
 * @param {boolean} state - flag for upload disable/enable
 */
function setUploadRestriction(state) {
    logoUploadRunning = state;
    $('.confirm-logo-upload').prop('disabled', state);
}

/**
 * Uploads the image, through input or drag&drop behavior
 * @param {Object} uploadData - the data for file upload
 */
function uploadLogo(uploadData) {
    if (!uploadData.file || !uploadData.url) {
        return;
    }

    let file = uploadData.file;
    let componentId = uploadData.componentId;
    let url = uploadData.url;
    let formData = new FormData();
    let $context = $(`.logo-selection-line[data-component-id="${componentId}"]`);

    formData.append('file', file);

    if (url && !logoUploadRunning) {
        $('.file-upload-logo', $context).spinner().start();
        $('.logo-process-error', $context).text('');
        setUploadRestriction(true);
        let timeout;

        let xhr = $.ajax({
            type: 'POST',
            url,
            data: formData,
            processData: false,
            contentType: false,
            complete: function (uploadResponse) {
                $('.file-upload-logo', $context).spinner().stop();
                clearTimeout(timeout);

                if (uploadResponse && uploadResponse.responseJSON) {
                    if (uploadResponse.responseJSON.isSuccessful && uploadResponse.responseJSON.response.status.success) {
                        let guid = uploadResponse.responseJSON.response.customLogo.id;
                        let fileName = uploadResponse.responseJSON.response.customLogo.originalFileName;
                        $('.summary-actions-comment').removeClass('d-none');

                        getSavedLogos().then(data => {
                            if (data) {
                                let $htmlResponse = $(data);

                                let $allContext = $('.logo-list-wrapper');
                                // Collects the information on the previously selected logos
                                let selectedElement = {};
                                let selectedArray = [];

                                $allContext.find('.selected').each(function () {
                                    const compId = $(this).attr('data-component-id');
                                    const generatedId = $(this).attr('data-guid');
                                    selectedElement = {
                                        compId: compId,
                                        generatedId: generatedId
                                    };
                                    selectedArray.push(selectedElement);
                                });

                                // Places logos all logos in all '.logo-list-wrapper' sections
                                // This unfortunately overrides selections and data-component-id
                                $allContext.html($htmlResponse);

                                // Iterates through all logos and fixes their 'data-component-id' value
                                // This is due to the previous step setting this data to a uniform value
                                let $customLogos = $('.custom-logo-button');
                                let hasNewLogo = false;
                                for (let index = 0; index < $customLogos.length; index++) {
                                    const element = $customLogos[index];
                                    let $logoParentId = $(element).parents('.logo-list-wrapper').attr('data-component-id');
                                    $(element).attr('data-component-id', `${$logoParentId}`);
                                    // removes '.selected' class from the template wrapper
                                    if ($(element).hasClass('.selected') && $logoParentId === '') {
                                        $(element).removeClass('.selected');
                                    }
                                    if ($(element).data('status') === 0) {
                                        hasNewLogo = true;
                                    }
                                }
                                if (hasNewLogo) {
                                    $('.type-logo-selection-representative-message').removeClass('d-none');
                                } else {
                                    $('.type-logo-selection-representative-message').addClass('d-none');
                                }

                                // Refresh references after ajax DOM reload
                                let $currentContext = $(`.logo-list-wrapper[data-component-id="${componentId}"]`);
                                let $newestLogo = $currentContext.find(`button[data-guid="${guid}"]`);
                                let uiField = store.state.getField(componentId, 'LOGO NAME');
                                uiField.$el = $(uiField.selector, $currentContext);

                                // Reselect previously selected elements
                                for (let index = 0; index < selectedArray.length; index++) {
                                    const prevSelected = selectedArray[index];
                                    const prevButton = $(`.logo-list-wrapper[data-component-id="${prevSelected.compId}"]`).find(`button[data-guid="${prevSelected.generatedId}"]`);
                                    prevButton.click();
                                }

                                if (uiField.$el && uiField.$el.length) {
                                    $newestLogo.trigger('change', [fileName, {
                                        previewUrl: $newestLogo.data('preview-url')
                                    }]);
                                    $(`.logoGUID[data-component-id="${componentId}"]`).val(guid).trigger('change');
                                }

                                discardLogoSelection(componentId);
                                setUploadRestriction(false);
                                toggleUpload(uiField.$el, true);
                            }
                        });
                    } else {
                        $('.logo-process-error', $context).text(uploadResponse.responseJSON.errMsg);
                        discardLogoSelection(componentId);
                        setUploadRestriction(false);
                    }
                } else {
                    $('.logo-process-error', $context).text(store.resources.errors.logoTimeout);
                    discardLogoSelection(componentId);
                    setUploadRestriction(false);
                }
            }
        });

        timeout = setTimeout(() => {
            xhr.abort();
        }, 7000);
    }
}

/**
 * Toggles the sign in tooltip on logo form
 */
function showLoginPrompt() {
    $('.logo-loginprompt-tooltip').addClass('show');

    setTimeout(() => {
        $('.logo-loginprompt-tooltip').removeClass('show');
    }, 3000);
}

/**
 * Init Text selection functions
 */
function initTextOption() {
    // Init text input char counter
    store.cache.$modal.on('input', '.text-selection-input, .summary-comment-textarea', function (e) {
        var maxlength = parseInt($(this).attr('maxlength'), 10);
        if ($(this).val().length > maxlength) {
            e.preventDefault();
            $(this).val($(this).val().slice(0, maxlength));
        }
        updateCharCount($(this));
    });

    store.cache.$modal.on('mouseenter mouseleave', '.text-selection-input, .summary-comment-textarea', function () {
        $(this).toggleClass('border border-dark');
    });

    // Lock scrolling while mobile keyboard opens to prevent pushing focused input outside screen
    // Release scrolling right after
    store.cache.$modal.on('click', '.text-selection-input', function () {
        if (utils.mediaBreakpointDown('md')) {
            store.cache.$modal.addClass('lock-scroll');

            setTimeout(() => {
                store.cache.$modal.removeClass('lock-scroll');
            }, 1000);
        }
    });

    store.cache.$modal.on('click', '.selection-box-content-font', function () {
        $(this).trigger('change', $(this).data('value'));
    });

    store.cache.$modal.on('click', '.selection-box-content-color', function () {
        $(this).trigger('change', $(this).data('value'));
    });
}

/**
 * Init Stock selection functions
 */
function initStockOption() {
    store.cache.$modal.on('click', '.stock-designs-button', function () {
        let val = $(this).data('value');
        let componentId = $(this).data('component-id');
        let description = $(this).data('design-description');
        let $context = $(`.stock-selection-line[data-component-id="${componentId}"]`);
        let $stockDescription = $('.stock-description-wrapper', $context);
        $(this).trigger('change', val);

        if (description) {
            const str = description;
            const arr = str.replace('-', '').split(/([0-9]+)/);
            $stockDescription.html(arr.slice(0, 1) + '<br />' + arr.slice(1).join(''));
        } else {
            $stockDescription.text($stockDescription.data('default'));
        }
    });

    store.cache.$modal.on('click', '.clear-selection-stock', function () {
        let $this = $(this);
        let componentId = $this.data('componentId');
        let $context = $(`.stock-selection-line[data-component-id="${componentId}"]`);

        var clearLine = function () {
            let $description = $('.stock-description-wrapper', $context);
            $description.text($description.data('default'));
        };
        showAreYouSureOverlay(componentId, clearLine);
    });

    store.cache.$modal.on('click', '.selection-box-content-position', function () {
        $(this).trigger('change', $(this).data('value'));
    });
}

/**
 * Init Flag selection functions
 */
function initFlagOption() {
    store.cache.$modal.on('click', '.flag-selection-button', function () {
        $(this).trigger('change', $(this).data('value'));
    });

    store.cache.$modal.on('click', '.flag-size-selection-link', function () {
        store.cache.$flagSizeOverlay.show();
    });

    store.cache.$modal.on('click', '.flag-size-close', function () {
        store.cache.$flagSizeOverlay.hide();
    });
}

/**
 * Sets up the ui for the user to accept uploading his logo
 * @param {string} componentId - componentId
 * @param {Object} file - the file blob
 */
function setUserUploadConfirm(componentId, file) {
    let uploadData = {
        file,
        url: store.resources.url.uploadLogo,
        componentId
    };
    let $context = $(`.logo-selection-line[data-component-id="${componentId}"]`);

    $('.file-name', $context).text(file.name);
    $('.confirm-logo-upload').data('uploadData', uploadData);
    store.cache.$permissionLogoOverlay.data('component-id', componentId).show();
}

/**
 * Prepares a selected logo for upload and validates the file
 * @param {Object} file - the file blob
 * @param {string} componentId - unique component id
 */
function userSelectLogo(file, componentId) {
    let $context = $(`.logo-selection-line[data-component-id="${componentId}"]`);
    let $uploaderMessages = $('.uploader-message', $context);
    let image = new Image();
    image.src = URL.createObjectURL(file);

    image.onerror = () => {
        $uploaderMessages.addClass('d-none');
        $('.uploader-file-error', $context).removeClass('d-none');
        $(`.uploader-complete[data-component-id="${componentId}"]`).removeAttr('src').addClass('d-none');
        setUserUploadConfirm(componentId, file);
    };

    image.onload = () => {
        setUserUploadConfirm(componentId, file);
        showLogoUploadPreview(file, componentId);
    };

    $('.uploader-file-error', $context).addClass('d-none');
}

/**
 * Init Logo selection functions
 */
function initLogoOption() {
    store.cache.$modal.on('dragover dragenter dragleave drop', '.file-upload-logo', function (e) {
        // Needs prevent for 'drop' event to register and from image drop in tab default behavior
        e.preventDefault();
        e.stopPropagation();
    });

    store.cache.$modal.on('dragenter', '.file-upload-logo', function () {
        $(this).addClass('highlight');
    });

    store.cache.$modal.on('dragleave', '.file-upload-logo', function () {
        $(this).removeClass('highlight');
    });

    store.cache.$modal.on('drop', '.file-upload-logo', function (e) {
        let $this = $(this);

        if ($this.hasClass('disabled')) {
            showLoginPrompt();
            $this.removeClass('highlight');
        } else if (e.originalEvent.dataTransfer.files.length) {
            let componentId = $this.data('component-id');
            let file = e.originalEvent.dataTransfer.files[0];
            userSelectLogo(file, componentId);
        }
    });

    store.cache.$permissionLogoOverlay.on('click', '.dismiss-action', function () {
        let componentId = store.cache.$permissionLogoOverlay.data('component-id');
        if (componentId !== undefined) {
            discardLogoSelection(componentId);
            store.state.setComplete(store.state.getForm(componentId).steps[0].id, componentId, false);
        }

        store.cache.$permissionLogoOverlay.hide().data('component-id', null);
    });

    store.cache.$modal.on('click', '.confirm-logo-upload', function () {
        let $this = $(this);
        let uploadData = $this.data('uploadData');
        $('.logo-process-error').text('');
        store.cache.$permissionLogoOverlay.hide().data('component-id', null);
        uploadLogo(uploadData);
    });

    store.cache.$modal.on('change', '.img-upload-input', function () {
        let componentId = $(this).data('component-id');
        let file = $(this)[0].files[0];
        userSelectLogo(file, componentId);
    });

    store.cache.$modal.on('click', '.file-upload-logo', function () {
        $('.logo-process-error').text('');
        if ($(this).hasClass('disabled')) {
            showLoginPrompt();
        } else {
            // Avoid using label for attribute as the dom gets duplicated leading to duplicating id's
            $(`.img-upload-input[data-component-id="${$(this).data('component-id')}"]`).trigger('click');
        }
    });

    store.cache.$modal.on('click', '.logo-selection-clear-line', function () {
        let $this = $(this);
        let componentId = $this.data('componentId');
        $(`.selected-file-name[data-component-id="${componentId}"]`).text('');
        toggleUpload($this, false);
        var clearLine = function () {
            resetLogoUploadPreview(componentId);
        };
        showAreYouSureOverlay(componentId, clearLine);
    });

    // Selecting a saved logo
    store.cache.$modal.on('click', '.custom-logo-button', function () {
        let $this = $(this);
        let componentId = $this.data('componentId');
        let $context = $(`.logo-selection-line[data-component-id="${componentId}"]`);
        let $listOfButtons = $(`.logo-selection-line[data-component-id="${componentId}"]`).find('.custom-logo-button');

        $listOfButtons.removeClass('selected');
        $this.addClass('selected');

        // Pass the guid to LOGO NUMBER field
        $('.logoGUID', $context).trigger('change', $this.data('guid'));
        // Pass the file name through $this as LOGO NAME
        $this.trigger('change', [$this.data('value'), {
            previewUrl: $(this).data('preview-url')
        }]);
        toggleUpload($(this), true);
    });
}

/**
 * Init Templates functions
 */
function initTemplates() {
    loadTemplatesSelectorOptions();

    store.cache.$modal.on('click', '.selection-box-content-template', function () {
        let $this = $(this);

        $('.selection-box-label .selection-placeholder', '#templateSelector').hide();
        $('.selection-box-label .selection-label', '#templateSelector').text($(this).text()).show();

        if ($this.data('templateId')) {
            let selectedTemplate = store.globals.userTemplates.find(template => template.id === $this.data('templateId'));
            applyTemplate(selectedTemplate);
            // Set data to check if user made any updates after loading a template
            // Used to ask the user if new template should be saved
            store.globals.templateLoaded = selectedTemplate;

            // Disable option to save template and set validation data
            $('#templateSaveSection').addClass('d-none');
            $('#summary-template').prop('checked', false);
            addValidator.set('incompleteTemplateName', false);

            store.globals.isTemplateUntouched = true;

            $('#templateSelector').removeClass('active');
        }
    });

    $('#templateSelector').on('mouseenter', '.selection-box-content-template', function () {
        if (utils.mediaBreakpointUp('md')) {
            let templateId = $(this).data('templateId');
            let templateData = store.globals.userTemplates.find(template => template.id === templateId);
            let $absContext = $('.modal-body', store.cache.$modal);

            // Position the popup
            let position = $(this)[0].getBoundingClientRect();
            let absOffset = $absContext[0].getBoundingClientRect();
            let x = position.x - absOffset.x - 40;
            let y = position.y;

            $('.embroidery-preview-list-wrapper', store.cache.$modal).removeClass('d-none').css({
                top: y,
                left: x
            });

            loadPreviewList(templateData.data, store.cache.$modal.find('.embroidery-preview-list-wrapper'));
        }
    });

    $('#templateSelector').on('mouseleave', function () {
        $('.embroidery-preview-list-wrapper', store.cache.$modal).addClass('d-none');
    });

    store.cache.$modal.on('click', '.template-action-update', function () {
        if (store.globals.templateLoaded) {
            let loadedTemplate = store.globals.userTemplates.find(template => template.id === store.globals.templateLoaded.id);
            loadedTemplate.data = cloneDeep(store.export.data);

            saveTemplate(loadedTemplate);
            store.globals.templateLoaded = null;

            store.cache.$saveTemplateOverlay.hide();
            store.cache.$sectionAll.hide();
            store.cache.$sectionSummary.show();
        }
    });

    store.cache.$modal.on('click', '.template-action-discard', function () {
        store.globals.templateLoaded = null;
        store.cache.$saveTemplateOverlay.hide();
        store.cache.$sectionAll.hide();
        store.cache.$sectionSummary.show();
    });

    store.cache.$modal.on('click', '.template-action-new', function () {
        // Save a template
        if ($('#overlay-template-name').val()) {
            setTemplate($('#overlay-template-name').val());

            store.cache.$saveTemplateOverlay.hide();
            store.cache.$sectionAll.hide();
            store.cache.$sectionSummary.show();
        }
    });

    // Load the no saved template tooltips if applicable
    let $templateSectionSelectors = $('[data-select-type="type-templates"]', store.cache.$modal);

    if (store.globals.userTemplates.length) {
        $templateSectionSelectors.removeClass('no-templates');
    }

    if ($templateSectionSelectors.length) {
        // Configuration on tooltip for the main selection page
        let $tooltipMain = $templateSectionSelectors.filter('.type-block').find('.no-saved-tooltip-info-icon');
        $tooltipMain.tooltip({
            container: '#embroideryModal .modal-body',
            trigger: 'manual',
            html: true,
            offset: '0, 20',
            sanitize: false,
            placement: 'top'
        });

        // Sidebar navigation tooltip configuration
        let $tooltipSidebar = $templateSectionSelectors.filter('.type-block-sidebar').find('.no-saved-tooltip-info-icon');
        $tooltipSidebar.tooltip({
            container: '#embroideryModal .modal-body',
            trigger: 'manual',
            html: true,
            offset: '0, 20',
            sanitize: false,
            placement: 'left'
        });

        $templateSectionSelectors.on('mouseenter click', function () {
            if ($(this).hasClass('no-templates')) {
                let $tooltip = $(this).find('.no-saved-tooltip-info-icon');
                toggleTooltip($tooltip, true, 'notemplates-tooltip');
            }
        });
    }
}

/**
 * Updates the visual counter of completed embroideries
 */
function updateEmbroideryCount() {
    store.cache.$modal.find('.modal-body').attr('data-embroideries-count', store.state.completeCount);
    store.cache.$modal.find('.counter-steps-completed').text(store.state.completeCount);
}

/**
 * Disable other stock options after reaching the embroidery limit
 */
function limitEmbroideries() {
    $('.option-section-toggle:not(.type-block-sidebar-templates):not(.completed)').toggleClass('disabled', store.state.completeCount >= 3);
    store.cache.$nextEmbroideryButton.prop('disabled', store.state.completeCount >= 3);
}

/**
 * init embroidery type selection
 */
function initTypeSelection() {
    store.cache.$modal.on('click', '.option-section-toggle:not(.disabled):not(.no-templates)', function () {
        let sectionType = $(this).data('section');
        triggerZoomedView($('.type-selection[data-section="' + sectionType + '"] .common-selection-location-element.selected:first').data('value'));
        // Validate fields on section that's about to be navigated away from
        let prevSection = store.state.sections[store.state.currentSection];
        if (prevSection && !prevSection.valid && !prevSection.untouched) {
            prevSection.validateSectionFields();
        }

        // Clears form errors if no fields are filled out
        if (prevSection && prevSection.untouched) {
            prevSection.clearForms();
        }

        if (sectionType === 'TEXT') {
            textAreaAnimation();
        }

        showOptionSection(sectionType);
        parseErrors();

        $('.mobile-modal-header-heading').renderTemplate({
            mobileheading: store.resources.mobileHeading[sectionType]
        });

        // Scrolls to top of section when changing sections
        $('.has-custom-scrollbar, .modal').stop().animate({ scrollTop: 0 }, 25, 'linear');
    });
}

/**
 * init qty selection
 */
function initQTYSelection() {
    var $selectElement = $('.embroidery-qty-select');

    // Init radio buttons events
    store.cache.$modal.on('change', '[name="embroideryQtySelection"]', function () {
        if ($(this).val() === 'embroidery-qty') {
            $selectElement.removeAttr('disabled');
        } else {
            $selectElement.attr('disabled', 'disabled');
        }
    });

    store.cache.$modal.on('click', '.embroidery-qty-select-continue', function () {
        var selectedOption = $('[name="embroideryQtySelection"]:checked').val();
        var selectedQty = 1;

        switch (selectedOption) {
            case 'embroidery-all':
                selectedQty = store.globals.quantity;
                break;
            case 'embroidery-qty':
                selectedQty = $selectElement.val();
                break;
            default:
                break;
        }

        store.globals.appliedToQty = selectedQty;
        updateEmbroideryPricing();
        goToLanding();
    });
}

/**
 * Saves embrodiery data to localstorage, to resume embroidery process after login
 */
function setEmbroideryStorage() {
    let storedData = {
        componentsData: store.export,
        config: {
            pid: store.globals.pid,
            url: store.globals.url,
            pliuuid: store.globals.pliuuid,
            quantity: store.globals.quantity,
            appliedToQty: store.globals.appliedToQty,
            currentSection: store.state.currentSection
        }
    };

    window.localStorage.setItem('embroideryResume', JSON.stringify(storedData));
}

/**
 * Scrolls to newly added embroidery section on mobile
 * @param {Object} $section - the new section DOM object
 */
function scrollToSection($section) {
    if (utils.mediaBreakpointDown('md') && $section && $section.length) {
        let $previewImage = store.cache.$imageSection;
        $previewImage.removeClass('display-preview-image');

        let sectionTop = $section[0].getBoundingClientRect().top;
        let $header = $('.mobile-modal-header', store.cache.$modal);
        let top = (sectionTop + store.cache.$modal[0].scrollTop) - ($header.outerHeight() + 10);

        $previewImage.removeClass('display-preview-image');
        store.cache.$modal.stop().animate({ scrollTop: top }, 500, 'linear');
    }
}

/**
 * Returns proper tooltip string for the input step
 * @param {*} step The current step in the form
 * @returns {string} Returns the proper string statement
 */
function missingStepString(step) {
    var id = step ? step.id : null;
    var string = 'Please complete this section.';

    /* eslint-disable */
    switch (id) {
        case 'FREETEXT':
            string = 'Please enter text to continue.';
            break;
        case 'PLACEMENT':
            string = 'Please choose a location.';
            break;
        case 'FONT':
            string = 'Please choose a font.';
            break;
        case 'COLOR':
            string = 'Please choose a color.';
            break;
        case 'DESIGN':
            string = 'Please choose a design.';
            break;
        case 'LOGO NAME':
            string = 'Please upload a design.';
            break;
        case 'SIZE':
            string = 'Please select a size.';
            break;
        default:
            break;
    }
    return string;
    /* eslint-enable */
}

/**
 * Init Modal events
 * @param {Object} initialData - if provided preloads the data in the embroidery modal, same as loading a template
 */
function init(initialData) {
    store.globals.placementsData = store.cache.$modal.data('embroidery').placements;

    // Load text option events
    initTextOption();

    // Load stock option events
    initStockOption();

    // Load stock option events
    initFlagOption();

    // Load logo option events
    initLogoOption();

    // Load templates
    initTemplates();

    initSummarySection();

    initAddedToBag();

    // Init location selection - common for all options
    store.cache.$modal.on('click', '.common-selection-location-element', function () {
        if (!$(this).parents('.common-selection-location').hasClass('disabled') && !$(this).hasClass('placement-unavailable')) {
            let locationId = $(this).data('value');
            $(this).trigger('change', locationId);

            highlightLocation();
            triggerZoomedView(locationId);
            setPlacementsAvailability();
        }
    });

    store.cache.$document.on('click', '.zoom-info-future-discard', function (e) {
        e.stopPropagation();
        document.cookie = 'ignoreZoomInfo=true; expires=Thu, 18 Dec 2099 12:00:00 UTC; path=/';
        $(this).parents('.zoom-info-tooltip').removeClass('show');
    });

    store.cache.$document.on('embroidery:sectionValidity', function (e, data) {
        $(`.option-section-toggle[data-section="${data.type}"]`).toggleClass('completed', data.valid);
        // Go to review disabled if embroidery section not valid and not empty, or all sections empty
        $('.button-go-to-review').toggleClass('disabled', !store.state.valid);

        if (data.valid || data.untouched) {
            store.cache.$sectionError.addClass('invisible');
        }

        updateEmbroideryCount();
        limitEmbroideries();
        renderNewLineCtas();
    });

    // Creates a new component data model, html, and updates the DOM
    store.cache.$modal.on('click', '.add-line', function () {
        let componentType = $(this).data('componenttype');
        let currentComponents = store.export.data.filter(x => x.component === componentType);
        let lastComponent = currentComponents[currentComponents.length - 1];
        let count = currentComponents.length;
        let limit = limitMap[componentType];

        // Check allowed number of components
        if (count < limit) {
            const component = store.export.addComponent(store.globals.componentsData[componentType]);
            let $componentHTML = store.state.render(component);

            if (componentType === 'TEXT' && lastComponent) {
                // Populate the new text component with the values from the previous one, except the text line
                let textComponentsToUpdate = lastComponent.componentAttributes.filter(componentData => componentData.componentAttribute !== 'FREETEXT');
                component.updateAll(textComponentsToUpdate);
            } else {
                // component.updateAll() triggers renderNewLineCtas() else needs to run manually
                renderNewLineCtas();
            }

            setPlacementsLimits();

            $('.button-go-to-review').toggleClass('disabled', !store.state.valid);

            scrollToSection($componentHTML);
        }

        // Signal the user took action after loading template if the case
        store.globals.isTemplateUntouched = false;
        syncPreviews();
    });

    store.cache.$modal.on('click', '.button-go-next-option', function () {
        switch (store.state.currentSection) {
            case 'TEXT':
            case 'STOCK':
            case 'FLAG':
            case 'CUSTOMLOGO':
                var current = store.state.sections[store.state.currentSection];
                store.cache.$sectionError.toggleClass('invisible', current.valid || current.untouched);

                if (!current.valid && !current.untouched) {
                    // Show tooltip and add a custom class
                    toggleTooltip($(this), true, 'next-option-tooltip');
                    current.validateSectionFields();
                } else {
                    showNextSection();
                }
                break;

            default:
                showNextSection();
                break;
        }
    });

    if (!store.globals.appliedToQty) {
        store.globals.appliedToQty = store.globals.quantity;
    }

    if (store.globals.quantity > 1) {
        goToQtySelect();
    } else {
        goToLanding();
    }

    initQTYSelection();
    initTypeSelection();

    store.cache.$modal.on('click', '.button-go-to-summary, .button-go-to-review', function () {
        if (!$(this).hasClass('disabled')) {
            store.cache.$modal.find('.overall-error-message').addClass('d-none');
            goToSummary();
        } else {
            store.cache.$modal.find('.overall-error-message').removeClass('d-none');
        }
    });

    store.cache.$modal.on('click', '.button-go-to-typemenu', function () {
        goToLanding();

        $('.mobile-modal-header-heading').renderTemplate({
            mobileheading: store.resources.mobileHeading.default
        });

        $('.add-embroidery-error', store.cache.$modal).hide();
    });

    store.cache.$modal.on('click', '.image-selection-circle, .placement-preview-thumbs', function () {
        triggerZoomedView($(this).data('location'));
    });

    store.cache.$modal.on('click', '.image-selection-zoom-out-button', function () {
        store.cache.$imageSection.removeClass('display-preview-image');
        showZoomInfoTooltip();
        store.globals.selectedPlacement = null;
    });

    // Init selection boxes functionality
    store.cache.$modal.on('click', '.selection-box:not(.disabled) .selection-box-label', function () {
        $(this).closest('.selection-box').toggleClass('active');
    });

    // Update the data object when a field gets changed with a new value
    store.cache.$modal.on('change keyup', '[data-model]', function (e, val, params) {
        let $this = $(this);
        let property = $this.data('model');
        let componentId = $this.data('componentId');
        let value;
        if (val !== undefined) {
            value = val;
        } else { // Native change on the rest of the inputs
            value = $this.val();
        }

        if (value !== undefined && property) {
            let component = store.export.getComponent(componentId);
            if (component) {
                component.update(property, value, params);
            }
            var success = true;
            $('.common-selection-location-element.selected').each(function () {
                if ($(this).data('value') === 'P5L' || $(this).data('value') === 'P5R') {
                    if ($('#flag-size-selection-1_1:checked')) {
                        $('#flag-size-selection-1_1').prop('checked', false);
                        $('#flag-size-selection-0_1').prop('checked', true);
                        component.update('SIZE', 'S', params);
                        var validation = validateEmbroidery(store.cache.$modal.data('embroidery').components, window.store.export);
                        window.store.export.data = validation.data;
                    }
                    success = false;
                }
            });

            if (!$('.flag-size-selection-block').hasClass('disabled')) {
                if ((value === 'P5L' || value === 'P5R') || !success) {
                    $('.custom-control-input.view').prop('disabled', true);
                } else {
                    $('.custom-control-input.view').prop('disabled', false);
                }
            }
            highlightLocation();
            if (!$(e.currentTarget).is('#summary-comment')) {
                syncPreviews();
            }
        }
    });

    store.cache.$modal.on('click', '.common-clear-selection', function () {
        showAreYouSureOverlay($(this).data('componentId'));
    });

    store.cache.$modal.on('click', '.login-redirect', function (e) {
        e.preventDefault();
        setEmbroideryStorage();
        window.location.href = $(this).attr('href');
    });

    store.cache.$modal.on('click', '.position-overlay-close', function () {
        store.cache.$positionOverlay.hide();
    });

    // Update the fields values & styling running a separate function for each field with custom ui behavior
    store.cache.$document.on('embroidery:updateField', function (e, data) {
        store.cache.$modal.find('.overall-error-message').addClass('d-none');
        if (data.key === 'PLACEMENT') {
            handleDesignOverText();
        }

        let uiField = store.state.getField(data.id, data.key);
        if (uiField) {
            uiField.clearError();
            if (!(Object.keys(data.attribute).length === 0)) {
                let functionKey = data.attribute.componentAttribute.replace(' ', '_').toLowerCase();
                if (updateField[functionKey] && typeof updateField[functionKey] === 'function') {
                    // Some elements are populated after init, if change is called assume the element
                    // is now present in the DOM, so update the reference
                    if (!uiField.$el.length) {
                        uiField.$el = $(uiField.selector).filter(`[data-component-id="${data.id}"]`);
                    }
                    updateField[functionKey](uiField, data.attribute.attributeValue, data.attribute);
                }
            }

            // Signal the user took action after loading template if the case
            store.globals.isTemplateUntouched = false;

            // Emit an embroidery component is completed by the user
            let form = store.state.getForm(data.id);
            if (form && form.complete) {
                store.cache.$document.trigger('embroidery:componentComplete');
            }
            parseErrors();
        }
    });

    store.cache.$document.on('embroidery:componentComplete', function () {
        updateSummaryTotals();
    });

    if (initialData) {
        applyTemplate(initialData);
    } else {
        // Add all components defined in backend
        let keys = Object.keys(store.globals.componentsData);
        for (let i = 0; i < keys.length; i++) {
            const data = store.globals.componentsData[keys[i]];

            // Create component into data
            const component = store.export.addComponent(data);
            if (component) {
                // Render it
                store.state.render(component);
            }
        }
    }

    // Based on initial data above
    setPlacementsAvailability();

    store.cache.$modal.on('hidden.bs.modal', function () {
        $('.add-embroidery-error', store.cache.$modal).hide();

        $('.mobile-modal-header-heading').renderTemplate({
            mobileheading: store.resources.mobileHeading.default
        });

        // Clear saved embroidery from localstorage if user chooses to close the modal
        clearStoredEmbroidery();

        if (store && store.globals.pageContext === 'quickview' && $('#quickViewModal').is(':visible')) {
            // Fix scrolling side effects when embroidery modal closes over quickview modal
            $('body').addClass('modal-open');
        } else {
            // Unlocks background when modal is closed in a product page
            utils.lockBackground(false);
        }
    });

    store.cache.$modal.on('click tap', '.disabled', function () {
        var current = store.state.sections[store.state.currentSection];
        var nextStep = store.state.sections[store.state.currentSection].getNextStep();
        var $this = $(this);
        var toolTip = missingStepString(nextStep);
        current.validateSectionFields();
        $this.attr('data-trigger', 'click');
        $this.attr('data-original-title', toolTip);
        $this.attr('data-container', '#embroideryModal .modal-body');
        if (window.matchMedia('(min-width: 992px)').matches) {
            $this.attr('data-placement', 'left');
        }
        toggleTooltip($this, true, 'review-tooltip');
        // Cleanse the tooltip after use
        (function () {
            $this.attr('data-trigger', '');
            $this.attr('data-original-title', '');
            if (window.matchMedia('(min-width: 992px)').matches) {
                $this.attr('data-placement', '');
            }
        }());
    });

    store.cache.$modal.on('click', '.button-go-to-review', function () {
        switch (store.state.currentSection) {
            case 'TEXT':
            case 'STOCK':
            case 'FLAG':
            case 'CUSTOMLOGO':
                var current = store.state.sections[store.state.currentSection];
                store.cache.$sectionError.toggleClass('invisible', current.valid || current.untouched);
                current.validateSectionFields();
                break;
            default:
                break;
        }
    });

    store.cache.$modal.on('shown.bs.modal', function () {
        syncPreviews();
        showLogoRep();
    });

    store.cache.$locationMarkers.tooltip({
        container: '#embroideryModal .modal-body',
        trigger: 'manual',
        html: true,
        offset: '0, 20px, 0, 0',
        sanitize: false,
        placement: 'left'
    });

    store.cache.$nextEmbroideryButton.tooltip({
        container: '#embroideryModal .modal-body',
        trigger: 'manual',
        html: true,
        sanitize: false,
        offset: '0, 20px'
    });

    store.cache.$goToSummary.tooltip({
        container: '#embroideryModal .modal-body',
        trigger: 'manual',
        html: true,
        sanitize: false,
        offset: '0, 20px'
    });

    store.cache.$saveTemplateInfo.tooltip({
        container: '#embroideryModal .modal-body',
        trigger: 'hover',
        html: true,
        sanitize: false,
        offset: '0, 20px'
    });

    // Add 'theme' color according to contrast between product background image and buttons color
    if (Contrast.getValidContrast(store.globals.productColor, '#000')) {
        store.cache.$imageSection.addClass('dark-theme');
    } else {
        store.cache.$imageSection.addClass('light-theme');
    }
}

/**
 * Init Embroidery Modal
 * @param {config} config - Configuration object
 * @param {string} config.embroideryUrl - url to Embroidery display endpoint
 * @param {number} config.qty - item quantity
 * @param {string} config.productId - product id, variant or default to master
 * @param {string} config.pliuuid - productlineitem uuid, variant or default to master
 * @param {string} config.pageContext - the page context where embroidery is being loaded from, shipping, pdp etc, some elements differ based on it
 * @param {Object} config.initialData - if provided preloads the data in the embroidery modal, same as loading a template
 */
function initEmbroideryModal(config) {
    if (!config) {
        return;
    }

    $.spinner().start();

    // If modal is called from different scopes maintain the same data
    if (window.store) {
        store = window.store;
    }

    let pid = config.pid;
    let url = config.url;
    let qty = config.qty;
    let pliuuid = config.pliuuid;
    let pageContext = config.pageContext || 'global';
    let initialData = config.initialData;
    var isCommentBoxExpandable = false;
    if (initialData && initialData.data) {
        initialData.data = typeof initialData.data === 'string' ? JSON.parse(initialData.data) : initialData.data;
        initialData.data.forEach(function (Components) {
            if (Components.component === 'COMMENTS' && Components.componentAttributes.length > 0) {
                isCommentBoxExpandable = true;
            }
        });
    }

    if (store) {
        store.globals.quantity = qty;
    }

    // Embroidery tool opened multiple times, from different page contexts (PDP, minicart)
    if ((!window.store || // No embroidery modals opened in page yet
        window.store.globals.appliedToQty !== qty || window.store.globals.pid !== pid || // Embroidery tool opened multiple times, but for different products
        (pliuuid && window.store.globals.pliuuid && pliuuid !== window.store.globals.pliuuid) || // Embroidery tool opened multiple times, but for different line items
        window.store.globals.pageContext !== pageContext) && pid && url) {
        url = utils.appendParamToURL(url, 'addedQuantity', qty || 1);
        url = utils.appendParamToURL(url, 'pid', pid);
        if (pageContext) {
            url = utils.appendParamToURL(url, 'pageContext', pageContext);
        }

        $.ajax({
            url,
            success: function (data) {
                if (data.result) {
                    $.spinner().stop();
                    if ($('.add-to-cart-messages').length === 0) {
                        $('body').append(
                            '<div class="add-to-cart-messages"></div>'
                        );
                    }
                    var $productDetail = base.getSizeValidationProductDetail();
                    if (base.isSizeSelectionError(data.message, $productDetail)) {
                        base.showPdpSizeValidationError($productDetail, data.message, $('.is-sticky').length > 0);
                    } else {
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center" role="alert">'
                            + data.message
                            + '</div>'
                        );
                    }
                    setTimeout(function () {
                        $('.add-to-basket-alert').remove();
                    }, 5000);
                    return;
                }
                if (typeof data === 'string') {
                    if ($('#embroideryModal').length === 0) {
                        $('body').append(data);
                    } else {
                        $('#embroideryModal').replaceWith(data);
                    }
                } else {
                    $.spinner().stop();
                    return;
                }

                store.cache = {
                    $document: $(document),
                    $modal: $('#embroideryModal'),
                    $modalBody: $('#embroideryModal .modal-body'),
                    $addedModal: $('#embroideryAddedModal'),
                    $sidebar: $('.embroidery-selection-sidebar'),
                    $sectionAll: $('.secondary-section'),
                    $sectionQTY: $('.section-qty-selection'),
                    $sectionType: $('.section-type-selection'),
                    $sectionCommon: $('.section-common-selection'),
                    $sectionSummary: $('.section-summary'),
                    $optionsToggle: $('.option-section-toggle'),

                    $typeAll: $('.type-selection'),
                    $typeText: $('.type-text-selection'),
                    $imagePlacements: $('.image-selections-overlay'),
                    $typeStock: $('.type-stock-selection'),
                    $typeLogo: $('.type-logo-selection'),
                    $typeFlags: $('.type-flags-selection'),
                    $typeTemplates: $('.type-templates-selection'),
                    $addButtons: $('.embroidery-add-button'),

                    $areYouSureOverlay: $('#areYouSureOverlay'),
                    $positionOverlay: $('#positionOverlay'),
                    $saveTemplateOverlay: $('#saveTemplateOverlay'),
                    $permissionLogoOverlay: $('#permissionLogoOverlay'),
                    $flagSizeOverlay: $('#flagSizeOverlay'),
                    $embroiderySummaryList: $('.embroiderySummaryList'),
                    $nextEmbroideryButton: $('.button-go-next-option'),
                    $locationMarkers: $('.image-selection-circle'),
                    $goToSummary: $('.button-go-to-review'),
                    $saveTemplateInfo: $('.save-template-info'),
                    $imageSection: $('.image-section'),
                    $resources: $('.resources'),
                    $sectionError: $('.section-error'),
                    $addToCartError: $('.embroidery-addtocart-error'),
                    models: {
                        TEXT: $('[data-component-template="TEXT"]'),
                        STOCK: $('[data-component-template="STOCK"]'),
                        FLAG: $('[data-component-template="FLAG"]'),
                        CUSTOMLOGO: $('[data-component-template="CUSTOMLOGO"]')
                    }
                };

                let $resources = store.cache.$resources;
                store.resources = {
                    errors: {
                        colorIssue: $resources.data('color-error'),
                        generalSubmit: $resources.data('general-submit'),
                        formIncomplete: $resources.data('form-incomplete'),
                        logoTimeout: $resources.data('logo-timeout'),
                        addToCart: $resources.data('addtocart-error'),
                        updateCart: $resources.data('updatecart-error')
                    },
                    mobileHeading: {
                        TEXT: $resources.data('mobileheading-text'),
                        STOCK: $resources.data('mobileheading-stock'),
                        CUSTOMLOGO: $resources.data('mobileheading-logo'),
                        FLAG: $resources.data('mobileheading-flag'),
                        TEMPLATE: $resources.data('mobileheading-template'),
                        SUMMARY: $resources.data('mobileheading-summary'),
                        default: $resources.data('mobileheading-default')
                    },
                    labels: {
                        FREETEXT: $resources.data('label-freetext'),
                        PLACEMENT: $resources.data('label-placement'),
                        FONT: $resources.data('label-font'),
                        COLOR: $resources.data('label-color'),
                        DESIGN: $resources.data('label-design'),
                        'STOCK-DESIGN': $resources.data('label-stock-design'),
                        'FLAG-DESIGN': $resources.data('label-flag-design'),
                        POSITIONING: $resources.data('label-positioning'),
                        SIZE: $resources.data('label-size'),
                        'LOGO NAME': $resources.data('label-logo'),
                        price: $resources.data('label-price'),
                        each: $resources.data('label-each'),
                        positionDefaultText: $resources.data('positioning-default')
                    },
                    url: {
                        saveTemplate: $resources.data('save-template'),
                        flag: $resources.data('url-flag'),
                        stock: $resources.data('url-stock'),
                        uploadLogo: $resources.data('url-logoupload'),
                        getLogos: $resources.data('url-logolist')
                    }
                };

                let productData = store.cache.$modal.data('embroidery').product;
                store.globals = {
                    productColor: productData.productColor || '#fff',
                    backgroundImage: productData.backgroundImage,
                    embrodieryConfiguration: $('#embroideryModal').data('embroidery'),
                    componentsData: $('#embroideryModal').data('embroidery').components,
                    quantity: qty,
                    pid,
                    pageContext,
                    pliuuid: pliuuid,
                    url,
                    isCommentBoxExpandable: isCommentBoxExpandable,
                    pricing: {
                        currencySymbol: productData.currencySymbol,
                        product: {
                            value: productData.price.value,
                            formatted: productData.price.formatted
                        }
                    },
                    templateExpirationTime: 3600000 * 24
                };

                setReactiveProperty.call(store.globals, 'appliedToQty');
                // Price of embroideries for all products
                setReactiveProperty.call(store.globals.pricing, 'embrTotalFormatted');
                // Price of embroideries for one product
                setReactiveProperty.call(store.globals.pricing, 'embrSubTotalFormatted');
                // Added embroideries price * qty of products to which they were added
                setReactiveProperty.call(store.globals.pricing, 'totalEmbroideryPriceFormatted');

                store.globals.appliedToQty = (config && config.appliedToQty) ? config.appliedToQty : qty;
                store.globals.pricing.singleEmbroideryPrice = 0; // Price of embroideries added
                updateEmbroideryPricing();

                store.globals.userTemplates = [];
                if (store.cache.$modal.data('embroidery').templates && store.cache.$modal.data('embroidery').templates.length) {
                    store.globals.userTemplates = store.cache.$modal.data('embroidery').templates.map(templateData => JSON.parse(templateData));
                } else if (window.localStorage.getItem('savedEmbroideryTemplates')) {
                    let validTemplates = validateStoredTemplates();

                    if (validTemplates.length) {
                        store.globals.userTemplates = validTemplates;
                    }
                }

                store.state = new EmbroideryUi(store.globals.componentsData);
                store.export = new EmbroideryData();

                window.store = store;

                init(initialData);

                store.cache.$modal.modal('show');

                if (config.currentSection) {
                    showOptionSection(config.currentSection);
                }

                $.spinner().stop();
                $(document.body).triggerHandler('globale:updatePrices');
            }
        });
    } else {
        if (initialData) {
            applyTemplate(initialData);
        }

        if (config.currentSection) {
            showOptionSection(config.currentSection);
        } else if (store.globals.quantity > 1) {
            goToQtySelect();
        } else {
            goToLanding();
        }

        store.cache.$modal.modal('show');
        $.spinner().stop();
        $(document.body).triggerHandler('globale:updatePrices');
    }
}

/**
 * Loads embrodiery data from localstorage, to resume embroidery process after login
*/
function initEmbroideryResumeWatcher() {
    if ((~window.location.search.indexOf('redirectedUrl=3') || ~window.location.search.indexOf('redirectedUrl=5')) && !(window.embroidery && window.embroidery.resumeWatcherEnabled)) {
        let savedData = window.localStorage.getItem('embroideryResume');

        if (savedData) {
            savedData = JSON.parse(savedData);

            initEmbroideryModal({
                pid: savedData.config.pid,
                url: savedData.config.url,
                pliuuid: savedData.config.pliuuid,
                qty: savedData.config.quantity,
                appliedToQty: savedData.config.appliedToQty,
                initialData: savedData.componentsData,
                currentSection: savedData.config.currentSection
            });
        }

        // Prevent multiple calls if code is loaded multiple times on the same page
        if (!window.embroidery) {
            window.embroidery = {};
        }

        window.embroidery.resumeWatcherEnabled = true;
    }
}

module.exports = {
    checkEmbroiderySelection: checkEmbroiderySelection,
    initEmbroideryModal: initEmbroideryModal,
    loadPreviewList: loadPreviewList,
    renderPreview: renderPreview,
    initEmbroideryResumeWatcher: initEmbroideryResumeWatcher,
    validateStoredTemplates: validateStoredTemplates
};
